window.HayzCompleteSources = Object.freeze({
  "1_4.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1_4.png?v=1776868182&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "2_3.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/2_3.png?v=1776869046&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "294.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/294.webp?v=1778489272&width=1402&height=1402&pad_color=fefefe",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#fefefe"
  },
  "296.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/296.webp?v=1778489273&width=1402&height=1402&pad_color=fefefe",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#fefefe"
  },
  "3_2.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/3_2.png?v=1776869103&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "276.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/276.webp?v=1778489149&width=1402&height=1402&pad_color=fefefe",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#fefefe"
  },
  "hayz-solo-8785141891254-white-front-separate-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-solo-8785141891254-white-front-separate-oct01.png?v=1790884696&width=627&height=627&pad_color=fefefd",
    "width": 627,
    "height": 627,
    "method": "matched-background",
    "background": "#fefefd"
  },
  "hayz-solo-8785141891254-white-angle-separate-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-solo-8785141891254-white-angle-separate-oct01.png?v=1790884706&width=627&height=627&pad_color=fefefd",
    "width": 627,
    "height": 627,
    "method": "matched-background",
    "background": "#fefefd"
  },
  "4_2.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/4_2.png?v=1776869146&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "241.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/241.webp?v=1778489050&width=1402&height=1402&pad_color=f8f8f6",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#f8f8f6"
  },
  "hayz-solo-8785143201974-white-front-separate-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-solo-8785143201974-white-front-separate-oct01.png?v=1790884732&width=627&height=627&pad_color=fefdfd",
    "width": 627,
    "height": 627,
    "method": "matched-background",
    "background": "#fefdfd"
  },
  "hayz-solo-8785143201974-white-angle-separate-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-solo-8785143201974-white-angle-separate-oct01.png?v=1790884718&width=627&height=627&pad_color=fefefe",
    "width": 627,
    "height": 627,
    "method": "matched-background",
    "background": "#fefefe"
  },
  "5.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/5.png?v=1776869225&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "283.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/283.webp?v=1778489167&width=1402&height=1402&pad_color=fefefe",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#fefefe"
  },
  "290.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/290.webp?v=1778489167&width=1402&height=1402&pad_color=fefefe",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#fefefe"
  },
  "6.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/6.png?v=1776869264&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "256.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/256.webp?v=1778489118&width=1402&height=1402&pad_color=fefefe",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#fefefe"
  },
  "259.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/259.webp?v=1778489118&width=1402&height=1402&pad_color=fefefe",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#fefefe"
  },
  "260.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/260.webp?v=1778489117&width=1402&height=1402&pad_color=fefefe",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#fefefe"
  },
  "7.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/7.png?v=1776869312&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "266.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/266.webp?v=1778489134&width=1402&height=1402&pad_color=fefefe",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#fefefe"
  },
  "hayz-solo-8785153720502-white-front-separate-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-solo-8785153720502-white-front-separate-oct01.png?v=1790884745&width=627&height=627&pad_color=faf9f6",
    "width": 627,
    "height": 627,
    "method": "matched-background",
    "background": "#faf9f6"
  },
  "hayz-solo-8785153720502-white-angle-separate-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-solo-8785153720502-white-angle-separate-oct01.png?v=1790884757&width=627&height=627&pad_color=fbf9f7",
    "width": 627,
    "height": 627,
    "method": "matched-background",
    "background": "#fbf9f7"
  },
  "hayz-solo-8785154638006-white-front-separate-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-solo-8785154638006-white-front-separate-oct01.png?v=1790884682&width=627&height=627&pad_color=fdfdfd",
    "width": 627,
    "height": 627,
    "method": "matched-background",
    "background": "#fdfdfd"
  },
  "hayz-solo-8785154638006-white-angle-separate-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-solo-8785154638006-white-angle-separate-oct01.png?v=1790884692&width=627&height=627&pad_color=fcfcfc",
    "width": 627,
    "height": 627,
    "method": "matched-background",
    "background": "#fcfcfc"
  },
  "hayz-solo-8785155719350-white-front-separate-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-solo-8785155719350-white-front-separate-oct01.png?v=1790884734&width=627&height=627&pad_color=fafaf8",
    "width": 627,
    "height": 627,
    "method": "matched-background",
    "background": "#fafaf8"
  },
  "hayz-solo-8785156997302-white-front-separate-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-solo-8785156997302-white-front-separate-oct01.png?v=1790884757&width=627&height=627&pad_color=fefefe",
    "width": 627,
    "height": 627,
    "method": "matched-background",
    "background": "#fefefe"
  },
  "hayz-solo-8785156997302-white-angle-separate-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-solo-8785156997302-white-angle-separate-oct01.png?v=1790884771&width=627&height=627&pad_color=fdfcfb",
    "width": 627,
    "height": 627,
    "method": "matched-background",
    "background": "#fdfcfb"
  },
  "hayz-solo-8785157947574-white-front-separate-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-solo-8785157947574-white-front-separate-oct01.png?v=1790884707&width=627&height=627&pad_color=fbfbfa",
    "width": 627,
    "height": 627,
    "method": "matched-background",
    "background": "#fbfbfa"
  },
  "hayz-solo-8785157947574-white-angle-separate-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-solo-8785157947574-white-angle-separate-oct01.png?v=1790884717&width=627&height=627&pad_color=fcfcfa",
    "width": 627,
    "height": 627,
    "method": "matched-background",
    "background": "#fcfcfa"
  },
  "hayz-solo-8785222992054-white-angle-separate-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-solo-8785222992054-white-angle-separate-oct01.png?v=1790884816&width=627&height=627&pad_color=fdfcfc",
    "width": 627,
    "height": 627,
    "method": "matched-background",
    "background": "#fdfcfc"
  },
  "1_6.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1_6.png?v=1776875624&width=1000&height=1000&pad_color=fefefe",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#fefefe"
  },
  "2_5.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/2_5.png?v=1776875826&width=1000&height=1000&pad_color=fcfcfc",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#fcfcfc"
  },
  "4.2.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/4.2.png?v=1776876000&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "4.1.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/4.1.png?v=1776876000&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "72.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/72.webp?v=1778487244&width=1402&height=1402&pad_color=f9f9f9",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#f9f9f9"
  },
  "76.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/76.webp?v=1778487249&width=1402&height=1402&pad_color=f5f4f1",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#f5f4f1"
  },
  "6_2.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/6_2.png?v=1776876219&width=1000&height=1000&pad_color=fcfcfc",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#fcfcfc"
  },
  "7_2.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/7_2.png?v=1776876273&width=1000&height=1000&pad_color=fcfcfc",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#fcfcfc"
  },
  "111.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/111.webp?v=1778487469&width=1402&height=1402&pad_color=fcfcfc",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#fcfcfc"
  },
  "8_1.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/8_1.png?v=1776876315&width=1000&height=1000&pad_color=fcfcfc",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#fcfcfc"
  },
  "9_1.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/9_1.png?v=1776876357&width=1000&height=1000&pad_color=fcfcfc",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#fcfcfc"
  },
  "108.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/108.webp?v=1778487434&width=1402&height=1402&pad_color=fafafa",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#fafafa"
  },
  "10.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/10.png?v=1776876520&width=1000&height=1000&pad_color=fcfcfc",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#fcfcfc"
  },
  "1_7.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1_7.png?v=1777361880&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "2_6.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/2_6.png?v=1777361936&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "3_4.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/3_4.png?v=1777362004&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "hayz-solo-8788488716470-white-front-separate-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-solo-8788488716470-white-front-separate-oct01.png?v=1790884833&width=627&height=627&pad_color=fcfcfc",
    "width": 627,
    "height": 627,
    "method": "matched-background",
    "background": "#fcfcfc"
  },
  "4_4.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/4_4.png?v=1777362049&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "png_16.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/png_16.webp?v=1778486588&width=1402&height=1402&pad_color=fefefe",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#fefefe"
  },
  "1.2_1.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1.2_1.png?v=1777362236&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "png21.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/png21.webp?v=1778486589&width=1402&height=1402&pad_color=fdfdfd",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#fdfdfd"
  },
  "hayz-bed-8788489273526-white.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-bed-8788489273526-white.png?v=1790781113&width=1536&height=1536&pad_color=fefefe",
    "width": 1536,
    "height": 1536,
    "method": "matched-background",
    "background": "#fefefe"
  },
  "2_7.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/2_7.png?v=1777362298&width=1000&height=1000&pad_color=fefefc",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#fefefc"
  },
  "hayz-bed-8788489404598-white.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-bed-8788489404598-white.png?v=1790781127&width=1536&height=1536&pad_color=fefefe",
    "width": 1536,
    "height": 1536,
    "method": "matched-background",
    "background": "#fefefe"
  },
  "3_5.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/3_5.png?v=1777362427&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "5_2.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/5_2.png?v=1777362546&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "png_22.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/png_22.webp?v=1778486635&width=1402&height=1402&pad_color=fefefe",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#fefefe"
  },
  "png_24.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/png_24.webp?v=1778486634&width=1402&height=1402&pad_color=fefefe",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#fefefe"
  },
  "6_3.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/6_3.png?v=1777362635&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "hayz-solo-8789023522998-white-front-separate-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-solo-8789023522998-white-front-separate-oct01.png?v=1790884860&width=627&height=627&pad_color=fcfbfa",
    "width": 627,
    "height": 627,
    "method": "matched-background",
    "background": "#fcfbfa"
  },
  "hayz-solo-8789023522998-white-angle-separate-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-solo-8789023522998-white-angle-separate-oct01.png?v=1790884873&width=627&height=627&pad_color=fcfaf8",
    "width": 627,
    "height": 627,
    "method": "matched-background",
    "background": "#fcfaf8"
  },
  "1_8.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1_8.png?v=1777445863&width=1402&height=1402&pad_color=fefefe",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#fefefe"
  },
  "1_9.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1_9.png?v=1777445982&width=1000&height=1000&pad_color=fcfcfc",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#fcfcfc"
  },
  "238.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/238.webp?v=1778488991&width=1402&height=1402&pad_color=fefefe",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#fefefe"
  },
  "2_8.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/2_8.png?v=1777446036&width=1000&height=1000&pad_color=f8f9f8",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#f8f9f8"
  },
  "229.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/229.webp?v=1778488978&width=1402&height=1402&pad_color=fefefe",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#fefefe"
  },
  "1_10.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1_10.png?v=1777446175&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "Copy_of_1_copy_2_0f1be167-c425-484a-ab68-d50c6c79abc9.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/Copy_of_1_copy_2_0f1be167-c425-484a-ab68-d50c6c79abc9.webp?v=1784125590&width=1402&height=1402&pad_color=f8f8f8",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#f8f8f8"
  },
  "1_11.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1_11.png?v=1777446256&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "png2web.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/png2web.webp?v=1778486079&width=1402&height=1402&pad_color=fefefe",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#fefefe"
  },
  "Copy_of_1_s_8b88240c-b110-4395-ab6b-7c062ec6f6ef.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/Copy_of_1_s_8b88240c-b110-4395-ab6b-7c062ec6f6ef.png?v=1784114774&width=1402&height=1402&pad_color=ffffff",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "2.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/2.png?v=1777446326&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "Copy_of_1_s_cdf09dfa-6eea-4f45-bf30-b77a8b0d3aff.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/Copy_of_1_s_cdf09dfa-6eea-4f45-bf30-b77a8b0d3aff.png?v=1784114738&width=1402&height=1402&pad_color=ffffff",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "3_6.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/3_6.png?v=1777446471&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "png11.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/png11.webp?v=1778485921&width=1402&height=1402&pad_color=f6f6f6",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#f6f6f6"
  },
  "png4.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/png4.webp?v=1778485924&width=1402&height=1402&pad_color=f4f4f4",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#f4f4f4"
  },
  "Copy_of_3s_0bef024a-f9e6-4288-8fe0-da806dd93db4.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/Copy_of_3s_0bef024a-f9e6-4288-8fe0-da806dd93db4.png?v=1784114671&width=1402&height=1402&pad_color=ffffff",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "1.1_2.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1.1_2.png?v=1777446939&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "345.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/345.webp?v=1778490095&width=1402&height=1402&pad_color=fafafa",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#fafafa"
  },
  "2.1.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/2.1.png?v=1777446986&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "3.1_1.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/3.1_1.png?v=1777447030&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "310.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/310.webp?v=1778489971&width=1402&height=1402&pad_color=f5f4f2",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#f5f4f2"
  },
  "311.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/311.webp?v=1778489971&width=1402&height=1402&pad_color=f7f7f7",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#f7f7f7"
  },
  "5_3.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/5_3.png?v=1777447115&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "319.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/319.webp?v=1778490008&width=1402&height=1402&pad_color=f8f6f6",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#f8f6f6"
  },
  "6_4.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/6_4.png?v=1777447163&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "306.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/306.webp?v=1778489942&width=1402&height=1402&pad_color=fbf6f6",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#fbf6f6"
  },
  "1_12.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1_12.png?v=1777447275&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "144.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/144.webp?v=1778487643&width=1402&height=1402&pad_color=fefefe",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#fefefe"
  },
  "145.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/145.webp?v=1778487643&width=1402&height=1402&pad_color=fefefe",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#fefefe"
  },
  "2_9.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/2_9.png?v=1777447481&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "161.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/161.webp?v=1778487668&width=1402&height=1402&pad_color=fefefe",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#fefefe"
  },
  "3_7.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/3_7.png?v=1777447532&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "4_6.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/4_6.png?v=1777447568&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "157.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/157.webp?v=1778487655&width=1402&height=1402&pad_color=fbfbfb",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#fbfbfb"
  },
  "5_4.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/5_4.png?v=1777447866&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "190.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/190.webp?v=1778487684&width=1402&height=1402&pad_color=fefefe",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#fefefe"
  },
  "196.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/196.webp?v=1778487683&width=1402&height=1402&pad_color=fefefe",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#fefefe"
  },
  "1.1_3.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1.1_3.png?v=1777876427&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "1.3.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1.3.png?v=1777876427&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "1.2_2.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1.2_2.png?v=1777876427&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "Copy_of_2_57d5d15d-c16a-4951-8e03-6879acd50a23.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/Copy_of_2_57d5d15d-c16a-4951-8e03-6879acd50a23.webp?v=1784126540&width=1402&height=1402&pad_color=ffffff",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "2.1_1.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/2.1_1.png?v=1777876493&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "2.1_1f6d4f41-76ce-405f-aafb-8a78147ef79a.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/2.1_1f6d4f41-76ce-405f-aafb-8a78147ef79a.png?v=1784126325&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "Copy_of_1_62326a8d-387c-4afa-98bd-5ad0a2aeb24e.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/Copy_of_1_62326a8d-387c-4afa-98bd-5ad0a2aeb24e.webp?v=1784126475&width=1402&height=1402&pad_color=ffffff",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "3.1_2.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/3.1_2.png?v=1777876611&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "3.2_1.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/3.2_1.png?v=1777876611&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "Copy_of_3_ea1fb0cb-e3cd-4d94-b9fc-a5c8ff894181.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/Copy_of_3_ea1fb0cb-e3cd-4d94-b9fc-a5c8ff894181.webp?v=1784126139&width=1402&height=1402&pad_color=ffffff",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "4.1_1.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/4.1_1.png?v=1777876712&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "4.2_1.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/4.2_1.png?v=1777876712&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "Copy_of_4_4eaa8a61-8ae1-4029-aca9-57c4610ae4a4.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/Copy_of_4_4eaa8a61-8ae1-4029-aca9-57c4610ae4a4.webp?v=1784125986&width=1402&height=1402&pad_color=ffffff",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "1.1_4.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1.1_4.png?v=1777876942&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "1.2_3.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1.2_3.png?v=1777876942&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "2.1_2.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/2.1_2.png?v=1777876991&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "2.2_1.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/2.2_1.png?v=1777876991&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "3_8.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/3_8.png?v=1777877054&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "4_7.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/4_7.png?v=1777877121&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "5_5.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/5_5.png?v=1777877174&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "1_13.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1_13.png?v=1777877307&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "504.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/504.webp?v=1778490696&width=1402&height=1402&pad_color=fefefe",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#fefefe"
  },
  "507.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/507.webp?v=1778490688&width=1402&height=1402&pad_color=faf9f7",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#faf9f7"
  },
  "2_10.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/2_10.png?v=1777877361&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "5569.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/5569.webp?v=1778490756&width=1402&height=1402&pad_color=f9f7f8",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#f9f7f8"
  },
  "654.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/654.webp?v=1778490769&width=1402&height=1402&pad_color=f8f8f8",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#f8f8f8"
  },
  "3_9.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/3_9.png?v=1777877406&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "406.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/406.webp?v=1778490646&width=1402&height=1402&pad_color=fefefe",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#fefefe"
  },
  "4_8.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/4_8.png?v=1777877457&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "801.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/801.webp?v=1778490790&width=1402&height=1402&pad_color=fefefe",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#fefefe"
  },
  "807.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/807.webp?v=1778490790&width=1402&height=1402&pad_color=eeeae6",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#eeeae6"
  },
  "647.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/647.webp?v=1778491826&width=1402&height=1402&pad_color=f8f7f8",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#f8f7f8"
  },
  "1.2_4.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1.2_4.png?v=1777877645&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "785.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/785.webp?v=1778491827&width=1402&height=1402&pad_color=f9f9f9",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#f9f9f9"
  },
  "2.1_3.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/2.1_3.png?v=1777877752&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "2.2_2.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/2.2_2.png?v=1777877752&width=1000&height=1000&pad_color=fefefe",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#fefefe"
  },
  "6555557.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/6555557.webp?v=1778491886&width=1402&height=1402&pad_color=fafafa",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#fafafa"
  },
  "3.1_3.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/3.1_3.png?v=1777877866&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "3.2_2.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/3.2_2.png?v=1777877865&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "4.2_2.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/4.2_2.png?v=1777877922&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "4.1_2.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/4.1_2.png?v=1777877922&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "1_15.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1_15.png?v=1777878063&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "Copy_of_1_1_62c88176-1f5e-40b3-90e7-8ddd8e378548.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/Copy_of_1_1_62c88176-1f5e-40b3-90e7-8ddd8e378548.webp?v=1784127658&width=1402&height=1402&pad_color=ffffff",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "2.2_3.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/2.2_3.png?v=1777878178&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "2.3.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/2.3.png?v=1777878178&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "2.1_4.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/2.1_4.png?v=1777878178&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "01445.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/01445.webp?v=1778491964&width=1402&height=1402&pad_color=fefefe",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#fefefe"
  },
  "Copy_of_2_1_b26549a1-e04e-4d97-b364-312fa223cd67.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/Copy_of_2_1_b26549a1-e04e-4d97-b364-312fa223cd67.webp?v=1784127576&width=1402&height=1402&pad_color=ffffff",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "3.1_4.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/3.1_4.png?v=1777878229&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "3.2_3.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/3.2_3.png?v=1777878229&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "05487877874.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/05487877874.webp?v=1778491985&width=1402&height=1402&pad_color=ececec",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#ececec"
  },
  "Copy_of_3_1_327b58bb-84a9-4a74-aff2-2fe684d8e5a3.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/Copy_of_3_1_327b58bb-84a9-4a74-aff2-2fe684d8e5a3.webp?v=1784127493&width=1402&height=1402&pad_color=ffffff",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "png28.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/png28.webp?v=1778657516&width=1402&height=1402&pad_color=f7f6f3",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#f7f6f3"
  },
  "png26.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/png26.webp?v=1778657516&width=1402&height=1402&pad_color=f7f7f7",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#f7f7f7"
  },
  "4_13.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/4_13.png?v=1784031125&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "2_9_e9b37274-c97d-4c3f-9dfc-00b2ea2f4dba.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/2_9_e9b37274-c97d-4c3f-9dfc-00b2ea2f4dba.png?v=1788649476&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "11_9664613b-a9ab-4807-a355-c136419d1f14.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/11_9664613b-a9ab-4807-a355-c136419d1f14.png?v=1788649476&width=1000&height=1000&pad_color=fefffe",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#fefffe"
  },
  "1.1_3_bed1c895-7446-43da-80dc-1436e030529b.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1.1_3_bed1c895-7446-43da-80dc-1436e030529b.png?v=1788649476&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "1_10_979313d1-b888-41c8-836a-0c7f48431eb4.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1_10_979313d1-b888-41c8-836a-0c7f48431eb4.png?v=1788649488&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "1_9_938254af-6582-4613-8f0c-dba1d75efe24.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1_9_938254af-6582-4613-8f0c-dba1d75efe24.png?v=1788649488&width=1000&height=1000&pad_color=fcfcfc",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#fcfcfc"
  },
  "2.1_3_19908d5e-5525-47af-ac09-ec536f5bddec.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/2.1_3_19908d5e-5525-47af-ac09-ec536f5bddec.png?v=1788649499&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "10_6ea8da52-5ac9-4e62-a2f2-97a85f55bdae.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/10_6ea8da52-5ac9-4e62-a2f2-97a85f55bdae.png?v=1788649499&width=1000&height=1000&pad_color=fcfcfc",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#fcfcfc"
  },
  "1_12_84c416a0-d178-4e2f-91f0-ee5b61130233.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1_12_84c416a0-d178-4e2f-91f0-ee5b61130233.png?v=1788837036&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "9_a2da20d7-b638-490d-906d-f0b29493d4b5.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/9_a2da20d7-b638-490d-906d-f0b29493d4b5.png?v=1788837036&width=1000&height=1000&pad_color=fcfbfc",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#fcfbfc"
  },
  "2.1_1_651b12f7-3982-47f3-91b2-93bb422cb860.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/2.1_1_651b12f7-3982-47f3-91b2-93bb422cb860.png?v=1788837036&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "4_6_3a072777-f14b-4e04-9dd2-c5ccdcc63691.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/4_6_3a072777-f14b-4e04-9dd2-c5ccdcc63691.png?v=1788837037&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "3_3_e23306f7-0ff1-455f-8d70-9524f7279383.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/3_3_e23306f7-0ff1-455f-8d70-9524f7279383.png?v=1788837037&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "1.1_3_b6f54b97-8a96-4577-abff-1eccc27b2da5.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1.1_3_b6f54b97-8a96-4577-abff-1eccc27b2da5.png?v=1788837037&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "5_4_ed1ce96a-5095-433b-b05b-96195020d14e.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/5_4_ed1ce96a-5095-433b-b05b-96195020d14e.png?v=1788837037&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "7_1_0072b86a-1ee4-4baa-8f0d-084bd3feebec.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/7_1_0072b86a-1ee4-4baa-8f0d-084bd3feebec.png?v=1788837037&width=1000&height=1000&pad_color=fefffe",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#fefffe"
  },
  "3_7_ab99a9c2-5391-47cb-81cf-ea47725b5d4d.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/3_7_ab99a9c2-5391-47cb-81cf-ea47725b5d4d.png?v=1788837038&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "13_32e61427-d610-4a2f-8c8e-82392f9771cc.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/13_32e61427-d610-4a2f-8c8e-82392f9771cc.png?v=1788837039&width=1000&height=1000&pad_color=fefffe",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#fefffe"
  },
  "4.1_1_c3415cf0-e55f-4d57-8c9c-7a2133f70d6c.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/4.1_1_c3415cf0-e55f-4d57-8c9c-7a2133f70d6c.png?v=1788837038&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "png28_df83a6cc-bbf1-4a4d-8ca9-815de7fa4184.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/png28_df83a6cc-bbf1-4a4d-8ca9-815de7fa4184.webp?v=1788837039&width=1402&height=1402&pad_color=f7f6f4",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#f7f6f4"
  },
  "1_4_7511adc1-34cd-4a74-86f5-8140c8b11a66.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1_4_7511adc1-34cd-4a74-86f5-8140c8b11a66.png?v=1788837039&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "2_1d9ee2bd-7c87-4a54-8733-6d14a8853999.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/2_1d9ee2bd-7c87-4a54-8733-6d14a8853999.png?v=1788837039&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "4_13_fa49d83e-f0c6-4c9d-ba03-bef10df484f5.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/4_13_fa49d83e-f0c6-4c9d-ba03-bef10df484f5.png?v=1788837040&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "4_2_42049e4a-b83e-4efe-bb33-1cc295864ad1.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/4_2_42049e4a-b83e-4efe-bb33-1cc295864ad1.png?v=1788837040&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "3_6_fde1e7b2-5a66-42bc-93a8-02573ab5d6a0.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/3_6_fde1e7b2-5a66-42bc-93a8-02573ab5d6a0.png?v=1788837040&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "3_5_0fcd11c8-61fd-4037-ae53-467af245d6c0.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/3_5_0fcd11c8-61fd-4037-ae53-467af245d6c0.png?v=1788837040&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "5_488a1b3d-52b4-475a-9733-25aecde93404.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/5_488a1b3d-52b4-475a-9733-25aecde93404.png?v=1788837040&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "4_4_898ea395-090b-441b-8eb9-7efe765f5be6.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/4_4_898ea395-090b-441b-8eb9-7efe765f5be6.png?v=1788837040&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "2_7_b4b3d96e-97fc-4493-a2e5-c49fa75773d0.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/2_7_b4b3d96e-97fc-4493-a2e5-c49fa75773d0.png?v=1788837041&width=1000&height=1000&pad_color=fefefc",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#fefefc"
  },
  "1_4_fe2d725a-6029-4821-9b63-5b5615c12cb9.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1_4_fe2d725a-6029-4821-9b63-5b5615c12cb9.png?v=1788837041&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "3_4_84cf7fc3-c895-4d33-8231-bedaec7d9c80.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/3_4_84cf7fc3-c895-4d33-8231-bedaec7d9c80.png?v=1788837041&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "1.1_1_ce154c60-060d-47a4-b89d-ba346de08605.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1.1_1_ce154c60-060d-47a4-b89d-ba346de08605.png?v=1788837042&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "3_2_8e35c00b-84b0-4754-afc1-622c381d97ac.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/3_2_8e35c00b-84b0-4754-afc1-622c381d97ac.png?v=1788837042&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "1_7_e6af1057-7e40-437c-b95f-a12fa55ead84.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1_7_e6af1057-7e40-437c-b95f-a12fa55ead84.png?v=1788837042&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "6_3_b2425692-4ac9-4fa5-8b1a-d6d80c83ee5c.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/6_3_b2425692-4ac9-4fa5-8b1a-d6d80c83ee5c.png?v=1788837042&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "6_7c7eb677-4927-429d-99e9-eddcfe47e547.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/6_7c7eb677-4927-429d-99e9-eddcfe47e547.png?v=1788837042&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "1.1_2_be17905c-9fa2-4f25-880d-c8d9d7e6d9af.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1.1_2_be17905c-9fa2-4f25-880d-c8d9d7e6d9af.png?v=1788837042&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "2.1_3_3ee8a837-a397-4f9f-a2a6-624482188e73.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/2.1_3_3ee8a837-a397-4f9f-a2a6-624482188e73.png?v=1788837043&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "2_5_17f578a3-046c-4dae-bf27-5472a47f5a31.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/2_5_17f578a3-046c-4dae-bf27-5472a47f5a31.png?v=1788837043&width=1000&height=1000&pad_color=fcfcfc",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#fcfcfc"
  },
  "3.1_1_1899e343-ff82-4f20-858e-4de278c68cc8.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/3.1_1_1899e343-ff82-4f20-858e-4de278c68cc8.png?v=1788837043&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "3.1_3_0bdd4959-a59c-42f7-8002-24de7b736359.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/3.1_3_0bdd4959-a59c-42f7-8002-24de7b736359.png?v=1788837044&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "8_1_d3d5386f-dbfc-4e37-8f5a-07b210863182.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/8_1_d3d5386f-dbfc-4e37-8f5a-07b210863182.png?v=1788837044&width=1000&height=1000&pad_color=fcfcfc",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#fcfcfc"
  },
  "1_15_0d38a13c-bd4d-4238-a08b-e2f75fe1815f.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1_15_0d38a13c-bd4d-4238-a08b-e2f75fe1815f.png?v=1788837044&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "4.2_2_600a5995-f0ba-4daa-8f6c-75fc12bf9671.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/4.2_2_600a5995-f0ba-4daa-8f6c-75fc12bf9671.png?v=1788837044&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "4.2_f79bc51e-884a-48ce-8676-05704072815f.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/4.2_f79bc51e-884a-48ce-8676-05704072815f.png?v=1788837045&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "3.1_4_217ec7c9-2c6c-4936-bf4b-7cbe6e1fbeaf.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/3.1_4_217ec7c9-2c6c-4936-bf4b-7cbe6e1fbeaf.png?v=1788837044&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "647_85ff9544-0b5b-4850-b6f5-b7dcf0c757f1.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/647_85ff9544-0b5b-4850-b6f5-b7dcf0c757f1.webp?v=1788837045&width=1402&height=1402&pad_color=f8f6f7",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#f8f6f7"
  },
  "9_1_2fce6219-48a1-45fb-aff4-32b9d1c46772.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/9_1_2fce6219-48a1-45fb-aff4-32b9d1c46772.png?v=1788837045&width=1000&height=1000&pad_color=fcfcfc",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#fcfcfc"
  },
  "5_3_44374c09-2744-4a9d-8f4f-d7d07daeae6c.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/5_3_44374c09-2744-4a9d-8f4f-d7d07daeae6c.png?v=1788837045&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "3.1_3_9f81d79b-ad1c-4f77-9d76-5ea822478e47.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/3.1_3_9f81d79b-ad1c-4f77-9d76-5ea822478e47.png?v=1788837046&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "7_2_bfea1958-a4e2-4fdb-b4ea-815de84b619a.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/7_2_bfea1958-a4e2-4fdb-b4ea-815de84b619a.png?v=1788837046&width=1000&height=1000&pad_color=fcfcfc",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#fcfcfc"
  },
  "310_f6f925a5-3354-49d3-a408-7f384970e13c.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/310_f6f925a5-3354-49d3-a408-7f384970e13c.webp?v=1788837046&width=1402&height=1402&pad_color=f5f4f2",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#f5f4f2"
  },
  "4.2_2_88e90f3e-deb5-4d1e-9c5b-e582c2d9df02.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/4.2_2_88e90f3e-deb5-4d1e-9c5b-e582c2d9df02.png?v=1788837046&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "1_6_05c99ce7-56dd-4697-ab3b-465cd47cfb82.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1_6_05c99ce7-56dd-4697-ab3b-465cd47cfb82.png?v=1788837046&width=1000&height=1000&pad_color=fefefe",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#fefefe"
  },
  "1.1_2_c55b9fbf-24b2-4799-9959-02c0ace59725.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1.1_2_c55b9fbf-24b2-4799-9959-02c0ace59725.png?v=1788837046&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "1_13_aabebe04-0177-406c-969e-aee8071e008b.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1_13_aabebe04-0177-406c-969e-aee8071e008b.png?v=1788837047&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "1.1_4_e5996f99-033e-4ec1-b674-baf34bac0f33.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1.1_4_e5996f99-033e-4ec1-b674-baf34bac0f33.png?v=1788837047&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "3_9_b7f429fc-54fd-448d-9a51-7e2e314a4e04.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/3_9_b7f429fc-54fd-448d-9a51-7e2e314a4e04.png?v=1788837048&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "1_9_ab0eee6b-4991-41c7-87c2-56f4c4b3a0ae.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1_9_ab0eee6b-4991-41c7-87c2-56f4c4b3a0ae.png?v=1788837048&width=1000&height=1000&pad_color=fcfcfc",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#fcfcfc"
  },
  "2_35bc1a1a-fb43-4c57-9f42-156d4ea3b4cd.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/2_35bc1a1a-fb43-4c57-9f42-156d4ea3b4cd.png?v=1788837048&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "4_8_d3cdbcd1-4d9c-42da-a30e-897b8ace2b51.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/4_8_d3cdbcd1-4d9c-42da-a30e-897b8ace2b51.png?v=1788837048&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "2_8_81014abe-bda5-4233-91f2-9c75c11d7ba3.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/2_8_81014abe-bda5-4233-91f2-9c75c11d7ba3.png?v=1788837048&width=1000&height=1000&pad_color=f8f9f8",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#f8f9f8"
  },
  "1_10_0d5c97bb-edbf-4e24-be52-f5efb20a54c0.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1_10_0d5c97bb-edbf-4e24-be52-f5efb20a54c0.png?v=1788837049&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "1_11_804e4a6c-641f-445d-b916-3a54410ed283.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1_11_804e4a6c-641f-445d-b916-3a54410ed283.png?v=1788837049&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "5_5_b8552ec1-3387-442d-b74f-8c36401c50cf.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/5_5_b8552ec1-3387-442d-b74f-8c36401c50cf.png?v=1788837049&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "4_4_cf5b54c4-358d-463b-a8a4-77f9b350fc91.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/4_4_cf5b54c4-358d-463b-a8a4-77f9b350fc91.png?v=1788837049&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "5_3_22cafeed-192b-40ed-be72-b1a1baa340a3.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/5_3_22cafeed-192b-40ed-be72-b1a1baa340a3.png?v=1788837049&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "1_8_495a8894-9863-4592-994d-12328dff33c0.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1_8_495a8894-9863-4592-994d-12328dff33c0.png?v=1788837050&width=1402&height=1402&pad_color=fefefe",
    "width": 1402,
    "height": 1402,
    "method": "matched-background",
    "background": "#fefefe"
  },
  "1_5_cce9d04f-0e7e-49ed-8840-2a4fb43a9f22.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/1_5_cce9d04f-0e7e-49ed-8840-2a4fb43a9f22.png?v=1788837050&width=1000&height=1000&pad_color=ffffff",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#ffffff"
  },
  "10_b7dfa777-754f-4197-81fd-61857822ab9b.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/10_b7dfa777-754f-4197-81fd-61857822ab9b.png?v=1788837051&width=1000&height=1000&pad_color=fcfcfc",
    "width": 1000,
    "height": 1000,
    "method": "matched-background",
    "background": "#fcfcfc"
  },
  "251.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-expanded-background-25b5b9b07cf4a050-oct02.png?v=1790938732",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-8785141104822-veneer-1-sep30.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-expanded-background-0d2bd1b060385655-oct02.png?v=1790938746",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "250.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-expanded-background-f4c3022cf266524e-oct02.png?v=1790938760",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "274.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-expanded-background-63a6aef5d49368fc-oct02.png?v=1790938774",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "279.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-expanded-background-47104b131fd94732-oct02.png?v=1790938791",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "278.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-expanded-background-08534895c5ee37f5-oct02.png?v=1790938805",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "280.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-expanded-background-e2a741a25ee75c9c-oct02.png?v=1790938819",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "282.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-eaa88108b1b3925a-oct02.png?v=1790940685",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-8785141104822-veneer-2-sep30.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-expanded-background-204d9ab196159a01-oct02.png?v=1790938849",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-8785141104822-veneer-3-sep30.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-expanded-background-65ee983cec127ec0-oct02.png?v=1790938863",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-8785141104822-veneer-4-sep30.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-expanded-background-74736906801d04b9-oct02.png?v=1790938880",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "247.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-26cad86b23992f55-oct02.png?v=1790940698",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "286.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-73da6e7b1109deb3-oct02.png?v=1790940710",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-8785149919414-lifestyle-sep30.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-066c70637fe9180b-oct02.png?v=1790940723",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-8785147199670-lifestyle-sep30.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-7b208132b48a14f0-oct02.png?v=1790940734",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-8785149198518-lifestyle-sep30.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-b889ab17a6d71790-oct02.png?v=1790940761",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-8785151328438-lifestyle-sep30.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-b0bb091610a0819b-oct02.png?v=1790940749",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-8785152442550-lifestyle-sep30.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-3935976b7d695579-oct02.png?v=1790940773",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "261.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-9c0a970c35915c86-oct02.png?v=1790940786",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-8785153720502-lifestyle-sep30.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-c755be47652fd762-oct02.png?v=1790940799",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-8785156997302-lifestyle-sep30.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-61a81f2c2b6e6c8e-oct02.png?v=1790940810",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-8785154638006-lifestyle-sep30.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-4d75dd2303f90a34-oct02.png?v=1790940823",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-8785155719350-lifestyle-sep30.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-eda13d79dab6fcd5-oct02.png?v=1790940835",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-8785159717046-lifestyle-sep30.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-a0a3c1682bdd461c-oct02.png?v=1790940847",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-8785161257142-lifestyle-sep30.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-459993d2ca514be4-oct02.png?v=1790940859",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-8785157947574-lifestyle-sep30.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-05197219b4125c87-oct02.png?v=1790940870",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "192.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-03260c7d86e3de95-oct02.png?v=1790944912",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-wood-8788488487094-finish-1-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8788488487094-wood-1-square-batch38-oct04.png?v=1791122717",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "564655.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-1c3fc84c82293a9d-oct02.png?v=1790942789",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "318.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-1c439507d4c14f6e-oct02.png?v=1790943127",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "153.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-1ce64ef26b8b1837-oct02.png?v=1790944901",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "73.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-203877095e96ffda-oct02.png?v=1790942995",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "203.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-244baefdb40a484b-oct02.png?v=1790944991",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "97774.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-25056be447a0468f-oct02.png?v=1790943079",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "120.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-29a71d9f56b8cce4-oct02.png?v=1790943031",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "painobed3.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-2c0ce74e2b05b0c4-oct02.png?v=1790942957",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "3499.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-2d5ce3c32a7325e1-oct02.png?v=1790943103",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "322.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-335714fda6b07895-oct02.png?v=1790943115",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "222.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-38f72cb3b366343b-oct02.png?v=1790945004",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-group-8875459477686-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875459477686-hayz-group-8875459477686-complete-lifestyle-oct03.png?v=1790991830",
    "width": 1254,
    "height": 1254
  },
  "215.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-3df2d051b372ac23-oct02.png?v=1790945016",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "png13.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-4217150fd698bd72-oct02.png?v=1790942892",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "400.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-450c448b1f208a7b-oct02.png?v=1790945051",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-sofa-8791647060150-panda-01-distinct.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-47767d4aef5ecf64-oct02.png?v=1790942838",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "30.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-4d0e34ec1d0f74d9-oct02.png?v=1790942943",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-wood-8788488716470-finish-1-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-4e4dde7a98043d1a-oct02.png?v=1790944768",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "113.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-4f28e56d16e2f80f-oct02.png?v=1790943019",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-alba-bench-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-59db3a890cfdc918-oct02.png?v=1790944835",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "91_40ade9c1-a38b-4c93-a02a-987a046f3e2c.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-5d12078587ce54c2-oct02.png?v=1790942983",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "210.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-672dd81425d2d6a5-oct02.png?v=1790944967",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-wood-8789023522998-finish-1-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-6c1c79082363dfd9-oct02.png?v=1790942851",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "130.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-714d0f2dff05fd30-oct02.png?v=1790943055",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "888.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-72992918ff57d95d-oct02.png?v=1790945064",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "501.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-73f93e5e212d1ec2-oct02.png?v=1790945027",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "ChatGPTImageJun2_2026_12_35_53PM_9.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-77f6a844fff09a79-oct02.png?v=1790944926",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "167.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-7aae040059a8301d-oct02.png?v=1790944874",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-8785175904438-lifestyle-sep30.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-83f99079ede6ce39-oct02.png?v=1790944715",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "231.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-938b9e1d2eecca27-oct02.png?v=1790944795",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "666664.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-93be3b4dcbc348f4-oct02.png?v=1790942822",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "478.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-9452ccc9210bf4cc-oct02.png?v=1790942777",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "335.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-97409a2c600df986-oct02.png?v=1790943138",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "235.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-9bb5d50c0448f68c-oct02.png?v=1790944782",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "0000.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-ac95be635c39db08-oct02.png?v=1790943091",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "png_8_copy.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-ae543780d78b364f-oct02.png?v=1790944846",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-wood-8788488552630-finish-1-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-b3579241ade1a23d-oct02.png?v=1790944744",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "png23.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-b6e0751d4b95a27d-oct02.png?v=1790942913",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-bed-8788489273526-curly-01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489273526-curly-01-fixed-oct02.png?v=1790968384",
    "width": 1254,
    "height": 1254,
    "method": "square-fixed-camera-color"
  },
  "100.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-b7fb06a89986e2d9-oct02.png?v=1790943006",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "127.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-ba63d04cd9057c76-oct02.png?v=1790942970",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "png_18.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-be7ced6d67bb694a-oct02.png?v=1790942865",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-solo-8788488716470-white-angle-separate-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-bf2d2ceac1896bb6-oct02.png?v=1790942806",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "2_copy.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-bfbcb48cc8304940-oct02.png?v=1790944820",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-group-8875462656182-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875462656182-hayz-group-8875462656182-complete-lifestyle-oct03.png?v=1790991816",
    "width": 1254,
    "height": 1254
  },
  "png25.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-c7efe69132a3f0b7-oct02.png?v=1790942925",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "307.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-cd4a881bd01e20d3-oct02.png?v=1790943251",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "5454546.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-d07311ddb2ddfa4e-oct02.png?v=1790943066",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "102.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-d2c963890d83910f-oct02.png?v=1790943044",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "301.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-d47d5b391939770b-oct02.png?v=1790943194",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "60.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-d51f241b8930b40b-oct02.png?v=1790944938",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-solo-8785155719350-white-angle-separate-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-d5acd16bf515c6e5-oct02.png?v=1790942764",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "199.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-d77349467e814542-oct02.png?v=1790944978",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-wood-8788488650934-finish-1-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-d80396bfe9c76699-oct02.png?v=1790944756",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-group-8875459346614-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-d8ee97dc1a186117-oct02.png?v=1790945076",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "141.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-dbfabe57226d8cff-oct02.png?v=1790944862",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-group-8875459444918-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875459444918-hayz-group-8875459444918-complete-lifestyle-oct03.png?v=1790991842",
    "width": 1254,
    "height": 1254
  },
  "51.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-eb24bb33c1a26361-oct02.png?v=1790944953",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-wood-8789031714998-finish-1-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789031714998-color-1-square-oct04.png?v=1791068788",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-color-edit",
    "background": "#ffffff"
  },
  "ChatGPTImageJun2_2026_12_58_23PM_9.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-efe6cd656203f8d0-oct02.png?v=1790944809",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "43.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-f041afb047e6a2fb-oct02.png?v=1790943151",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "668.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-ff753a2d3f710698-oct02.png?v=1790945038",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-group-8875463082166-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-ac2f042fb7047d0b-oct02.png?v=1790946371",
    "width": 1254,
    "height": 1254,
    "method": "extended-room"
  },
  "hayz-group-8875462688950-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875462688950-hayz-group-8875462688950-complete-lifestyle-oct03.png?v=1790991830",
    "width": 1254,
    "height": 1254
  },
  "hayz-group-8875462754486-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875462754486-hayz-group-8875462754486-complete-lifestyle-oct03.png?v=1790991845",
    "width": 1254,
    "height": 1254
  },
  "hayz-group-8875462721718-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875462721718-hayz-group-8875462721718-complete-lifestyle-oct03.png?v=1790991859",
    "width": 1254,
    "height": 1254
  },
  "hayz-group-8875462852790-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875462852790-hayz-group-8875462852790-complete-lifestyle-oct03.png?v=1790991992",
    "width": 1254,
    "height": 1254
  },
  "hayz-group-8875462787254-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875462787254-hayz-group-8875462787254-complete-lifestyle-png-retry-oct03.png?v=1790991925",
    "width": 1254,
    "height": 1254
  },
  "hayz-group-8875462918326-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-d6632ff397b7bfd0-oct02.png?v=1790947153",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-group-8875462820022-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875462820022-hayz-group-8875462820022-complete-lifestyle-oct03.png?v=1790991979",
    "width": 1254,
    "height": 1254
  },
  "hayz-group-8875462983862-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875462983862-hayz-group-8875462983862-complete-lifestyle-oct03.png?v=1790992005",
    "width": 1254,
    "height": 1254
  },
  "hayz-group-8875463016630-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875463016630-hayz-group-8875463016630-complete-lifestyle-oct03.png?v=1790992019",
    "width": 1254,
    "height": 1254
  },
  "hayz-group-8875463049398-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875463049398-hayz-group-8875463049398-complete-lifestyle-oct03.png?v=1790992515",
    "width": 1254,
    "height": 1254
  },
  "hayz-group-8875463114934-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875463114934-hayz-group-8875463114934-complete-lifestyle-oct03.png?v=1790992532",
    "width": 1254,
    "height": 1254
  },
  "hayz-group-8875463147702-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875463147702-hayz-group-8875463147702-complete-lifestyle-oct03.png?v=1790992547",
    "width": 1254,
    "height": 1254
  },
  "hayz-group-8875463180470-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875463180470-hayz-group-8875463180470-complete-lifestyle-oct03.png?v=1790992632",
    "width": 1254,
    "height": 1254
  },
  "hayz-group-8881114808502-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-1b9ca72aeda1724a-oct02.png?v=1790947760",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-group-8881114939574-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-aa5ec5a1d7d3713b-oct02.png?v=1790947773",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-group-8881114841270-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-43718db69ba7ecfa-oct02.png?v=1790947784",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-group-8881115037878-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-3ab048d181bdbdd2-oct02.png?v=1790947818",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-group-8881115070646-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-ccee5fd7a4039d3b-oct02.png?v=1790947894",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-group-8881115168950-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-450272a16433232a-oct02.png?v=1790947854",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-group-8881115234486-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-739b7bb926ec5f1a-oct02.png?v=1790947974",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-group-8881115300022-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-d30fcce22b6f0201-oct02.png?v=1790947937",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-group-8881115398326-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-7c50cbb7c3cb7c87-oct02.png?v=1790948093",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-group-8881115431094-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-132245007678b026-oct02.png?v=1790948013",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-group-8881115529398-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-84b04e20e497a38b-oct02.png?v=1790948052",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-group-8881115562166-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-49d02163b7ead4fd-oct02.png?v=1790948689",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-group-8881115660470-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-4482f7d7b0aa8b35-oct02.png?v=1790948713",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-group-8881115693238-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-5adc1fe738f1c0cd-oct02.png?v=1790948649",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-group-8881115791542-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-9724518db9862dba-oct02.png?v=1790948516",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-group-8881115857078-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-97bf7f68a43904f0-oct02.png?v=1790948470",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-group-8881115922614-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-890d109d2ad11007-oct02.png?v=1790948610",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-group-8881116020918-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-19d2026c919c4a98-oct02.png?v=1790948562",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "246.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-4cba57818a36576f-oct02.png?v=1790948702",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-wood-8785226858678-finish-1-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-c29e1aaab5643220-oct02.png?v=1790949386",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-wood-8785226858678-finish-2-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-d54a6adeac66d334-oct02.png?v=1790949411",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-wood-8785226858678-finish-3-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-738082411ba10465-oct02.png?v=1790949423",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-wood-8785226858678-finish-4-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-8de6dc41733dbbd7-oct02.png?v=1790949237",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-8785230954678-veneer-1-sep30.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-a529a8a622ca7335-oct02.png?v=1790949255",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-8785230954678-veneer-2-sep30.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-0aa9a7ae661f1c59-oct02.png?v=1790949295",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-8785230954678-veneer-3-sep30.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-5d5243947334185f-oct02.png?v=1790949338",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "hayz-8785230954678-veneer-4-sep30.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-complete-square-b83e1acab12630b5-oct02.png?v=1790949399",
    "width": 1254,
    "height": 1254,
    "method": "expanded-scene"
  },
  "png29.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-solis-full-live-oct02.png?v=1790966037",
    "width": 1254,
    "height": 1254,
    "method": "complete-bed-view"
  },
  "png_14.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-haven-full-detail-oct02.png?v=1790966050",
    "width": 1254,
    "height": 1254,
    "method": "complete-bed-view"
  },
  "png_12.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-terra-full-detail-oct02.png?v=1790966064",
    "width": 1254,
    "height": 1254,
    "method": "complete-bed-view"
  },
  "32.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-nara-full-detail-oct02.png?v=1790966076",
    "width": 1254,
    "height": 1254,
    "method": "complete-bed-view"
  },
  "png27.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-solis-full-detail-oct02.png?v=1790966088",
    "width": 1254,
    "height": 1254,
    "method": "complete-bed-view"
  },
  "hayz-bed-8788489175222-curly-04.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-template-8788489175222-oct02.png?v=1790966791",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-template"
  },
  "hayz-bed-8788489273526-curly-04.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-template-8788489273526-oct02.png?v=1790966803",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-template"
  },
  "hayz-bed-8788489404598-curly-04.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-template-8788489404598-oct02.png?v=1790966815",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-template"
  },
  "hayz-bed-8788489699510-curly-04.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-template-8788489699510-oct02.png?v=1790966854",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-template"
  },
  "hayz-bed-8788489896118-curly-04.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-template-8788489896118-oct02.png?v=1790966828",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-template"
  },
  "hayz-bed-8795742535862-curly-04.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-template-8795742535862-oct02.png?v=1790966842",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-template"
  },
  "hayz-bed-8821687845046-curly-04.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-template-8821687845046-oct02.png?v=1790966866",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-template"
  },
  "png_17.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-life-square-8788489175222-png_17-oct02.png?v=1790966878",
    "width": 1254,
    "height": 1254,
    "method": "background-extended-square"
  },
  "png19.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-life-square-8788489175222-png19-oct02.png?v=1790966891",
    "width": 1254,
    "height": 1254,
    "method": "background-extended-square"
  },
  "png24.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-life-square-8788489699510-png24-oct02.png?v=1790966905",
    "width": 1254,
    "height": 1254,
    "method": "background-extended-square"
  },
  "31.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-life-square-8788489896118-31-oct02.png?v=1790966916",
    "width": 1254,
    "height": 1254,
    "method": "background-extended-square"
  },
  "35.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-life-square-8788489896118-35-oct02.png?v=1790966941",
    "width": 1254,
    "height": 1254,
    "method": "background-extended-square"
  },
  "39.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-life-square-8788489896118-39-oct02.png?v=1790966930",
    "width": 1254,
    "height": 1254,
    "method": "background-extended-square"
  },
  "40.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-life-square-8788489896118-40-oct02.png?v=1790966954",
    "width": 1254,
    "height": 1254,
    "method": "background-extended-square"
  },
  "png_33.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-life-square-8788489896118-png_33-oct02.png?v=1790966967",
    "width": 1254,
    "height": 1254,
    "method": "background-extended-square"
  },
  "hayz-bed-8788489175222-curly-01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489175222-hayz-bed-8788489175222-curly-01-oct02.png?v=1790967499",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489175222-curly-03.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489175222-hayz-bed-8788489175222-curly-03-oct02.png?v=1790967547",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489175222-curly-06.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489175222-hayz-bed-8788489175222-curly-06-oct02.png?v=1790967510",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489175222-curly-07.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489175222-hayz-bed-8788489175222-curly-07-oct02.png?v=1790967535",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489175222-labubu-01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489175222-hayz-bed-8788489175222-labubu-01-oct02.png?v=1790967523",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489175222-labubu-09.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489175222-hayz-bed-8788489175222-labubu-09-oct02.png?v=1790967560",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489175222-labubu-12.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489175222-hayz-bed-8788489175222-labubu-12-oct02.png?v=1790967573",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489175222-labubu-15.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489175222-hayz-bed-8788489175222-labubu-15-oct02.png?v=1790967585",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489175222-labubu-17.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489175222-hayz-bed-8788489175222-labubu-17-oct02.png?v=1790967599",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489273526-curly-03.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489273526-hayz-bed-8788489273526-curly-03-oct02.png?v=1790967613",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489273526-curly-06.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489273526-hayz-bed-8788489273526-curly-06-oct02.png?v=1790967626",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489273526-curly-07.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489273526-hayz-bed-8788489273526-curly-07-oct02.png?v=1790967640",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489273526-labubu-01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489273526-hayz-bed-8788489273526-labubu-01-oct02.png?v=1790967652",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489273526-labubu-09.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489273526-hayz-bed-8788489273526-labubu-09-oct02.png?v=1790967665",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489273526-labubu-12.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489273526-hayz-bed-8788489273526-labubu-12-oct02.png?v=1790967677",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489273526-labubu-15.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489273526-hayz-bed-8788489273526-labubu-15-oct02.png?v=1790967689",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489273526-labubu-17.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489273526-hayz-bed-8788489273526-labubu-17-oct02.png?v=1790967700",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489404598-curly-01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489404598-hayz-bed-8788489404598-curly-01-oct02.png?v=1790967716",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489404598-curly-03.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489404598-hayz-bed-8788489404598-curly-03-oct02.png?v=1790967728",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489404598-curly-06.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489404598-hayz-bed-8788489404598-curly-06-oct02.png?v=1790967776",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489404598-curly-07.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489404598-hayz-bed-8788489404598-curly-07-oct02.png?v=1790967751",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489404598-labubu-01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489404598-hayz-bed-8788489404598-labubu-01-oct02.png?v=1790967740",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489404598-labubu-09.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489404598-hayz-bed-8788489404598-labubu-09-oct02.png?v=1790967764",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489404598-labubu-12.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489404598-hayz-bed-8788489404598-labubu-12-oct02.png?v=1790967789",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489404598-labubu-15.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489404598-hayz-bed-8788489404598-labubu-15-oct02.png?v=1790967801",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489404598-labubu-17.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489404598-hayz-bed-8788489404598-labubu-17-oct02.png?v=1790967813",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489699510-curly-01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489699510-hayz-bed-8788489699510-curly-01-oct02.png?v=1790967839",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489699510-curly-03.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489699510-hayz-bed-8788489699510-curly-03-oct02.png?v=1790967826",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489699510-curly-06.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489699510-hayz-bed-8788489699510-curly-06-oct02.png?v=1790967852",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489699510-curly-07.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489699510-hayz-bed-8788489699510-curly-07-oct02.png?v=1790967865",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489699510-labubu-01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489699510-hayz-bed-8788489699510-labubu-01-oct02.png?v=1790967877",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489699510-labubu-09.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489699510-hayz-bed-8788489699510-labubu-09-oct02.png?v=1790967889",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489699510-labubu-12.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489699510-hayz-bed-8788489699510-labubu-12-oct02.png?v=1790967901",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489699510-labubu-15.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489699510-hayz-bed-8788489699510-labubu-15-oct02.png?v=1790967925",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489699510-labubu-17.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489699510-hayz-bed-8788489699510-labubu-17-oct02.png?v=1790967913",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489896118-curly-01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489896118-hayz-bed-8788489896118-curly-01-oct02.png?v=1790967937",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489896118-curly-03.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489896118-hayz-bed-8788489896118-curly-03-oct02.png?v=1790967950",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489896118-curly-06.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489896118-hayz-bed-8788489896118-curly-06-oct02.png?v=1790967976",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489896118-curly-07.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489896118-hayz-bed-8788489896118-curly-07-oct02.png?v=1790967964",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489896118-labubu-01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489896118-hayz-bed-8788489896118-labubu-01-oct02.png?v=1790968001",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489896118-labubu-09.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489896118-hayz-bed-8788489896118-labubu-09-oct02.png?v=1790967988",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489896118-labubu-12.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489896118-hayz-bed-8788489896118-labubu-12-oct02.png?v=1790968013",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489896118-labubu-15.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489896118-hayz-bed-8788489896118-labubu-15-oct02.png?v=1790968025",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8788489896118-labubu-17.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489896118-hayz-bed-8788489896118-labubu-17-oct02.png?v=1790968038",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8795742535862-curly-01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8795742535862-hayz-bed-8795742535862-curly-01-oct02.png?v=1790968050",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8795742535862-curly-03.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8795742535862-hayz-bed-8795742535862-curly-03-oct02.png?v=1790968074",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8795742535862-curly-06.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8795742535862-hayz-bed-8795742535862-curly-06-oct02.png?v=1790968062",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8795742535862-curly-07.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8795742535862-hayz-bed-8795742535862-curly-07-oct02.png?v=1790968086",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8795742535862-labubu-01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8795742535862-hayz-bed-8795742535862-labubu-01-oct02.png?v=1790968102",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8795742535862-labubu-09.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8795742535862-hayz-bed-8795742535862-labubu-09-oct02.png?v=1790968113",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8795742535862-labubu-12.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8795742535862-hayz-bed-8795742535862-labubu-12-oct02.png?v=1790968124",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8795742535862-labubu-15.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8795742535862-hayz-bed-8795742535862-labubu-15-oct02.png?v=1790968136",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8795742535862-labubu-17.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8795742535862-hayz-bed-8795742535862-labubu-17-oct02.png?v=1790968148",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8821687845046-curly-01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8821687845046-hayz-bed-8821687845046-curly-01-oct02.png?v=1790968160",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8821687845046-curly-03.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8821687845046-hayz-bed-8821687845046-curly-03-oct02.png?v=1790968174",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8821687845046-curly-06.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8821687845046-hayz-bed-8821687845046-curly-06-oct02.png?v=1790968188",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8821687845046-curly-07.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8821687845046-hayz-bed-8821687845046-curly-07-oct02.png?v=1790968201",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8821687845046-labubu-01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8821687845046-hayz-bed-8821687845046-labubu-01-oct02.png?v=1790968214",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8821687845046-labubu-09.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8821687845046-hayz-bed-8821687845046-labubu-09-oct02.png?v=1790968229",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8821687845046-labubu-12.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8821687845046-hayz-bed-8821687845046-labubu-12-oct02.png?v=1790968240",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8821687845046-labubu-15.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8821687845046-hayz-bed-8821687845046-labubu-15-oct02.png?v=1790968263",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-bed-8821687845046-labubu-17.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8821687845046-hayz-bed-8821687845046-labubu-17-oct02.png?v=1790968251",
    "width": 1254,
    "height": 1254,
    "method": "fixed-camera-square-color"
  },
  "hayz-complete-square-b7762b0812c26d6e-oct02.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-whole-color-square-8788489273526-curly-01-fixed-oct02.png?v=1790968384",
    "width": 1254,
    "height": 1254,
    "method": "square-fixed-camera-color"
  },
  "254.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785128358070-254-oct02.png?v=1790973902",
    "width": 1254,
    "height": 1254
  },
  "255.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785128358070-255-oct02.png?v=1790973915",
    "width": 1254,
    "height": 1254
  },
  "292.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785139794102-292-oct02.png?v=1790973929",
    "width": 1254,
    "height": 1254
  },
  "295.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785139794102-295-oct02.png?v=1790973942",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785139794102-wood-1-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785139794102-hayz-solo-8785139794102-wood-1-oct01-oct02.png?v=1790974457",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785139794102-wood-2-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785139794102-hayz-solo-8785139794102-wood-2-oct01-oct02.png?v=1790974472",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785139794102-wood-3-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785139794102-hayz-solo-8785139794102-wood-3-oct01-oct02.png?v=1790974485",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785139794102-wood-4-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785139794102-hayz-solo-8785139794102-wood-4-oct01-oct02.png?v=1790974497",
    "width": 1254,
    "height": 1254
  },
  "240.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785141891254-240-oct02.png?v=1790974323",
    "width": 1254,
    "height": 1254
  },
  "284.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785143201974-284-oct02.png?v=1790974340",
    "width": 1254,
    "height": 1254
  },
  "285.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785143201974-285-oct02.png?v=1790974354",
    "width": 1254,
    "height": 1254
  },
  "287.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785143201974-287-oct02.png?v=1790974369",
    "width": 1254,
    "height": 1254
  },
  "288.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785143201974-288-oct02.png?v=1790974382",
    "width": 1254,
    "height": 1254
  },
  "289.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785143201974-289-oct02.png?v=1790974396",
    "width": 1254,
    "height": 1254
  },
  "257.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785143955638-257-oct02.png?v=1790974410",
    "width": 1254,
    "height": 1254
  },
  "258.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785143955638-258-oct02.png?v=1790974423",
    "width": 1254,
    "height": 1254
  },
  "262.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785144742070-262-oct02.png?v=1790974525",
    "width": 1254,
    "height": 1254
  },
  "265.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785144742070-265-oct02.png?v=1790974511",
    "width": 1254,
    "height": 1254
  },
  "269.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785144742070-269-oct02.png?v=1790974539",
    "width": 1254,
    "height": 1254
  },
  "270.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785144742070-270-oct02.png?v=1790974571",
    "width": 1254,
    "height": 1254
  },
  "271.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785144742070-271-oct02.png?v=1790974555",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785147199670-fabric-13-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785147199670-hayz-solo-8785147199670-fabric-13-oct01-oct02.png?v=1790975102",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785147199670-fabric-15-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785147199670-hayz-solo-8785147199670-fabric-15-oct01-oct02.png?v=1790975115",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785147199670-fabric-24-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785147199670-hayz-solo-8785147199670-fabric-24-oct01-oct02.png?v=1790975128",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785147199670-fabric-4-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785147199670-hayz-solo-8785147199670-fabric-4-oct01-oct02.png?v=1790975087",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785149198518-fabric-13-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785149198518-hayz-solo-8785149198518-fabric-13-oct01-oct02.png?v=1790975297",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785149198518-fabric-15-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785149198518-hayz-solo-8785149198518-fabric-15-oct01-oct02.png?v=1790975309",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785149198518-fabric-24-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785149198518-hayz-solo-8785149198518-fabric-24-oct01-oct02.png?v=1790975322",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785149198518-fabric-4-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785149198518-hayz-solo-8785149198518-fabric-4-oct01-oct02.png?v=1790975282",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785149919414-fabric-13-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785149919414-hayz-solo-8785149919414-fabric-13-oct01-oct02.png?v=1790976657",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785149919414-fabric-15-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785149919414-hayz-solo-8785149919414-fabric-15-oct01-oct02.png?v=1790976671",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785149919414-fabric-24-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785149919414-hayz-solo-8785149919414-fabric-24-oct01-oct02.png?v=1790976946",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785149919414-fabric-4-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785149919414-hayz-solo-8785149919414-fabric-4-oct01-oct02.png?v=1790975379",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785151328438-fabric-13-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785151328438-hayz-solo-8785151328438-fabric-13-oct01-oct02.png?v=1790976964",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785151328438-fabric-15-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785151328438-hayz-solo-8785151328438-fabric-15-oct01-oct02.png?v=1790976978",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785151328438-fabric-24-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785151328438-hayz-solo-8785151328438-fabric-24-oct01-oct02.png?v=1790976996",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785151328438-fabric-4-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785151328438-hayz-solo-8785151328438-fabric-4-oct01-oct02.png?v=1790975495",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785152442550-fabric-13-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785152442550-hayz-solo-8785152442550-fabric-13-oct01-oct02.png?v=1790977012",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785152442550-fabric-15-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785152442550-hayz-solo-8785152442550-fabric-15-oct01-oct02.png?v=1790977029",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785152442550-fabric-24-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785152442550-hayz-solo-8785152442550-fabric-24-oct01-oct02.png?v=1790977046",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785152442550-fabric-4-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785152442550-hayz-solo-8785152442550-fabric-4-oct01-oct02.png?v=1790975550",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785153720502-fabric-13-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785153720502-hayz-solo-8785153720502-fabric-13-oct01-oct02.png?v=1790975870",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785153720502-fabric-15-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785153720502-hayz-solo-8785153720502-fabric-15-oct01-oct02.png?v=1790977065",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785153720502-fabric-24-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785153720502-hayz-solo-8785153720502-fabric-24-oct01-oct02.png?v=1790977080",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785153720502-fabric-4-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785153720502-hayz-solo-8785153720502-fabric-4-oct01-oct02.png?v=1790975856",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785154638006-fabric-13-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785154638006-hayz-solo-8785154638006-fabric-13-oct01-oct02.png?v=1790976054",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785154638006-fabric-15-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785154638006-hayz-solo-8785154638006-fabric-15-oct01-oct02.png?v=1790976071",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785154638006-fabric-24-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785154638006-hayz-solo-8785154638006-fabric-24-oct01-oct02.png?v=1790976097",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785154638006-fabric-4-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785154638006-hayz-solo-8785154638006-fabric-4-oct01-oct02.png?v=1790976040",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785155719350-fabric-13-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785155719350-hayz-solo-8785155719350-fabric-13-oct01-oct02.png?v=1790976227",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785155719350-fabric-15-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785155719350-hayz-solo-8785155719350-fabric-15-oct01-oct02.png?v=1790976241",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785155719350-fabric-24-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785155719350-hayz-solo-8785155719350-fabric-24-oct01-oct02.png?v=1790976257",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785155719350-fabric-4-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785155719350-hayz-solo-8785155719350-fabric-4-oct01-oct02.png?v=1790976164",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785156997302-fabric-13-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785156997302-hayz-solo-8785156997302-fabric-13-oct01-oct02.png?v=1790976340",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785156997302-fabric-15-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785156997302-hayz-solo-8785156997302-fabric-15-oct01-oct02.png?v=1790976355",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785156997302-fabric-24-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785156997302-hayz-solo-8785156997302-fabric-24-oct01-oct02.png?v=1790976368",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785156997302-fabric-4-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785156997302-hayz-solo-8785156997302-fabric-4-oct01-oct02.png?v=1790976315",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785157947574-fabric-13-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785157947574-hayz-solo-8785157947574-fabric-13-oct01-oct02.png?v=1790976478",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785157947574-fabric-15-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785157947574-hayz-solo-8785157947574-fabric-15-oct01-oct02.png?v=1790976493",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785157947574-fabric-24-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785157947574-hayz-solo-8785157947574-fabric-24-oct01-oct02.png?v=1790976508",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785157947574-fabric-4-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785157947574-hayz-solo-8785157947574-fabric-4-oct01-oct02.png?v=1790976465",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785159717046-fabric-13-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785159717046-hayz-solo-8785159717046-fabric-13-oct01-oct02.png?v=1790976572",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785159717046-fabric-15-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785159717046-hayz-solo-8785159717046-fabric-15-oct01-oct02.png?v=1790976586",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785159717046-fabric-24-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785159717046-hayz-solo-8785159717046-fabric-24-oct01-oct02.png?v=1790976600",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785159717046-fabric-4-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785159717046-hayz-solo-8785159717046-fabric-4-oct01-oct02.png?v=1790976560",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785161257142-fabric-13-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785161257142-hayz-solo-8785161257142-fabric-13-oct01-oct03.png?v=1790992748",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785161257142-fabric-15-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785161257142-hayz-solo-8785161257142-fabric-15-oct01-oct03.png?v=1790992733",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785161257142-fabric-24-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785161257142-hayz-solo-8785161257142-fabric-24-oct01-oct03.png?v=1790992717",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785161257142-fabric-4-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785161257142-hayz-solo-8785161257142-fabric-4-oct01-oct02.png?v=1790977183",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785175904438-fabric-13-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785175904438-hayz-solo-8785175904438-fabric-13-oct01-oct02.png?v=1790977254",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785175904438-fabric-15-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785175904438-hayz-solo-8785175904438-fabric-15-oct01-oct02.png?v=1790977210",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785175904438-fabric-24-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785175904438-hayz-solo-8785175904438-fabric-24-oct01-oct02.png?v=1790977225",
    "width": 1254,
    "height": 1254
  },
  "hayz-solo-8785175904438-fabric-4-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785175904438-hayz-solo-8785175904438-fabric-4-oct01-oct02.png?v=1790977237",
    "width": 1254,
    "height": 1254
  },
  "95_be5c3bb8-b2a2-48c8-b2ee-1ce1e5e8382a.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785222992054-95_be5c3bb8-b2a2-48c8-b2ee-1ce1e5e8382a-oct02.png?v=1790977249",
    "width": 1254,
    "height": 1254
  },
  "126.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785224958134-126-oct02.png?v=1790977267",
    "width": 1254,
    "height": 1254
  },
  "118.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785231052982-118-oct03.png?v=1790992048",
    "width": 1254,
    "height": 1254
  },
  "123.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785231052982-123-oct03.png?v=1790992034",
    "width": 1254,
    "height": 1254
  },
  "hayz-wood-8785231052982-finish-1-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785231052982-hayz-wood-8785231052982-finish-1-lifestyle-oct03.png?v=1790992062",
    "width": 1254,
    "height": 1254
  },
  "103.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785231839414-103-oct03.png?v=1790992118",
    "width": 1254,
    "height": 1254
  },
  "104.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785231839414-104-oct03.png?v=1790992090",
    "width": 1254,
    "height": 1254
  },
  "107.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785231839414-107-oct03.png?v=1790992104",
    "width": 1254,
    "height": 1254
  },
  "hayz-wood-8785231839414-finish-1-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785231839414-hayz-wood-8785231839414-finish-1-lifestyle-oct03.png?v=1790992131",
    "width": 1254,
    "height": 1254
  },
  "133.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785233576118-133-oct03.png?v=1790992146",
    "width": 1254,
    "height": 1254
  },
  "135.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785233576118-135-oct03.png?v=1790992162",
    "width": 1254,
    "height": 1254
  },
  "hayz-wood-8785233576118-finish-1-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8785233576118-hayz-wood-8785233576118-finish-1-lifestyle-oct03.png?v=1790992175",
    "width": 1254,
    "height": 1254
  },
  "hayz-complete-square-eae0a7ffd67deecc-oct02.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875459444918-hayz-group-8875459444918-complete-lifestyle-oct03.png?v=1790991842",
    "width": 1254,
    "height": 1254
  },
  "hayz-group-8875459444918-complete-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875459444918-hayz-group-8875459444918-complete-lifestyle-oct03.png?v=1790991842",
    "width": 1254,
    "height": 1254
  },
  "hayz-complete-square-3a225d2e4516a27a-oct02.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875459477686-hayz-group-8875459477686-complete-lifestyle-oct03.png?v=1790991830",
    "width": 1254,
    "height": 1254
  },
  "hayz-group-8875459477686-complete-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875459477686-hayz-group-8875459477686-complete-lifestyle-oct03.png?v=1790991830",
    "width": 1254,
    "height": 1254
  },
  "hayz-complete-square-c7edb84b01a2c7cc-oct02.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875462656182-hayz-group-8875462656182-complete-lifestyle-oct03.png?v=1790991816",
    "width": 1254,
    "height": 1254
  },
  "hayz-group-8875462656182-complete-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875462656182-hayz-group-8875462656182-complete-lifestyle-oct03.png?v=1790991816",
    "width": 1254,
    "height": 1254
  },
  "hayz-complete-square-a8d6629dfd2179d2-oct02.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875462688950-hayz-group-8875462688950-complete-lifestyle-oct03.png?v=1790991830",
    "width": 1254,
    "height": 1254
  },
  "hayz-group-8875462688950-complete-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875462688950-hayz-group-8875462688950-complete-lifestyle-oct03.png?v=1790991830",
    "width": 1254,
    "height": 1254
  },
  "hayz-complete-square-2c0ff66a708e31d8-oct02.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875462721718-hayz-group-8875462721718-complete-lifestyle-oct03.png?v=1790991859",
    "width": 1254,
    "height": 1254
  },
  "hayz-group-8875462721718-complete-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875462721718-hayz-group-8875462721718-complete-lifestyle-oct03.png?v=1790991859",
    "width": 1254,
    "height": 1254
  },
  "hayz-complete-square-0e6b24baec4f0c32-oct02.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875462754486-hayz-group-8875462754486-complete-lifestyle-oct03.png?v=1790991845",
    "width": 1254,
    "height": 1254
  },
  "hayz-group-8875462754486-complete-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875462754486-hayz-group-8875462754486-complete-lifestyle-oct03.png?v=1790991845",
    "width": 1254,
    "height": 1254
  },
  "hayz-complete-square-81697fdf814fc8a9-oct02.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875462787254-hayz-group-8875462787254-complete-lifestyle-png-retry-oct03.png?v=1790991925",
    "width": 1254,
    "height": 1254
  },
  "hayz-group-8875462787254-complete-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875462787254-hayz-group-8875462787254-complete-lifestyle-png-retry-oct03.png?v=1790991925",
    "width": 1254,
    "height": 1254
  },
  "hayz-complete-square-8df6735376d5afc7-oct02.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875462820022-hayz-group-8875462820022-complete-lifestyle-oct03.png?v=1790991979",
    "width": 1254,
    "height": 1254
  },
  "hayz-group-8875462820022-complete-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875462820022-hayz-group-8875462820022-complete-lifestyle-oct03.png?v=1790991979",
    "width": 1254,
    "height": 1254
  },
  "hayz-complete-square-b794b44fe8fbae92-oct02.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875462852790-hayz-group-8875462852790-complete-lifestyle-oct03.png?v=1790991992",
    "width": 1254,
    "height": 1254
  },
  "hayz-group-8875462852790-complete-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875462852790-hayz-group-8875462852790-complete-lifestyle-oct03.png?v=1790991992",
    "width": 1254,
    "height": 1254
  },
  "hayz-complete-square-56f2b3b3a3831a8a-oct02.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875462983862-hayz-group-8875462983862-complete-lifestyle-oct03.png?v=1790992005",
    "width": 1254,
    "height": 1254
  },
  "hayz-group-8875462983862-complete-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875462983862-hayz-group-8875462983862-complete-lifestyle-oct03.png?v=1790992005",
    "width": 1254,
    "height": 1254
  },
  "hayz-complete-square-851e919236b2e023-oct02.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875463016630-hayz-group-8875463016630-complete-lifestyle-oct03.png?v=1790992019",
    "width": 1254,
    "height": 1254
  },
  "hayz-group-8875463016630-complete-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875463016630-hayz-group-8875463016630-complete-lifestyle-oct03.png?v=1790992019",
    "width": 1254,
    "height": 1254
  },
  "hayz-complete-square-9ab030c6f0bdbca3-oct02.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875463049398-hayz-group-8875463049398-complete-lifestyle-oct03.png?v=1790992515",
    "width": 1254,
    "height": 1254
  },
  "hayz-group-8875463049398-complete-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875463049398-hayz-group-8875463049398-complete-lifestyle-oct03.png?v=1790992515",
    "width": 1254,
    "height": 1254
  },
  "hayz-complete-square-78def1f17553aec0-oct02.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875463114934-hayz-group-8875463114934-complete-lifestyle-oct03.png?v=1790992532",
    "width": 1254,
    "height": 1254
  },
  "hayz-group-8875463114934-complete-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875463114934-hayz-group-8875463114934-complete-lifestyle-oct03.png?v=1790992532",
    "width": 1254,
    "height": 1254
  },
  "hayz-complete-square-e97738d1121738ee-oct02.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875463147702-hayz-group-8875463147702-complete-lifestyle-oct03.png?v=1790992547",
    "width": 1254,
    "height": 1254
  },
  "hayz-group-8875463147702-complete-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875463147702-hayz-group-8875463147702-complete-lifestyle-oct03.png?v=1790992547",
    "width": 1254,
    "height": 1254
  },
  "hayz-complete-square-49e32237a655c0be-oct02.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875463180470-hayz-group-8875463180470-complete-lifestyle-oct03.png?v=1790992632",
    "width": 1254,
    "height": 1254
  },
  "hayz-group-8875463180470-complete-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8875463180470-hayz-group-8875463180470-complete-lifestyle-oct03.png?v=1790992632",
    "width": 1254,
    "height": 1254
  },
  "hayz-group-8881116053686-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8881116053686-hayz-group-8881116053686-lifestyle-oct01-oct03.png?v=1790992652",
    "width": 1254,
    "height": 1254
  },
  "hayz-group-8881116151990-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8881116151990-hayz-group-8881116151990-lifestyle-oct01-oct03.png?v=1790992669",
    "width": 1254,
    "height": 1254
  },
  "hayz-group-8881116184758-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8881116184758-hayz-group-8881116184758-lifestyle-oct01-oct03.png?v=1790992684",
    "width": 1254,
    "height": 1254
  },
  "hayz-group-8881116283062-lifestyle-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-all-products-8881116283062-hayz-group-8881116283062-lifestyle-oct01-oct03.png?v=1790992702",
    "width": 1254,
    "height": 1254
  },
  "hayz-wood-8789031452854-finish-1-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-carrara-square-color-1-oct04.png?v=1791067325",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-color-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789031452854-finish-2-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-carrara-square-color-2-oct04.png?v=1791067336",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-color-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789031452854-finish-3-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-carrara-square-color-3-oct04.png?v=1791067349",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-color-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789031452854-finish-4-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-carrara-square-color-4-oct04.png?v=1791067361",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-color-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789031551158-finish-1-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789031551158-color-1-square-oct04.png?v=1791068745",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-color-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789031551158-finish-2-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789031551158-color-2-square-oct04.png?v=1791068756",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-color-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789031551158-finish-3-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789031551158-color-3-square-oct04.png?v=1791068767",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-color-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789031551158-finish-4-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789031551158-color-4-square-oct04.png?v=1791068776",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-color-edit",
    "background": "#ffffff"
  },
  "hayz-complete-square-ec5133a70832c307-oct02.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789031714998-color-1-square-oct04.png?v=1791068788",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-color-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789031714998-finish-2-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789031714998-color-2-square-oct04.png?v=1791068801",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-color-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789031714998-finish-3-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-studio-8789031714998-sep07.png",
    "width": 1254,
    "height": 1254,
    "method": "original fixed master, natural oak already matches",
    "background": "#ffffff"
  },
  "hayz-wood-8789031714998-finish-4-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789031714998-color-4-square-oct04.png?v=1791068812",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-color-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789032075446-finish-1-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789032075446-color-1-square-oct04.png?v=1791069526",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789032075446-finish-2-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-studio-8789032075446-sep07.png",
    "width": 1254,
    "height": 1254,
    "method": "original fixed master, warm brown already matches",
    "background": "#ffffff"
  },
  "hayz-wood-8789032075446-finish-3-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789032075446-color-3-square-oct04.png?v=1791069540",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789032075446-finish-4-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789032075446-color-4-square-oct04.png?v=1791069553",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789034238134-finish-1-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789034238134-color-1-square-oct04.png?v=1791069567",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789034238134-finish-2-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-studio-8789034238134-sep07.png",
    "width": 1254,
    "height": 1254,
    "method": "original fixed master, warm brown already matches",
    "background": "#ffffff"
  },
  "hayz-wood-8789034238134-finish-3-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789034238134-color-3-square-oct04.png?v=1791069577",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789034238134-finish-4-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789034238134-color-4-square-oct04.png?v=1791069588",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8790702915766-finish-1-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-studio-8790702915766-sep07.png",
    "width": 1254,
    "height": 1254,
    "method": "original fixed master, dark brown already matches",
    "background": "#ffffff"
  },
  "hayz-wood-8790702915766-finish-2-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8790702915766-color-2-square-oct04.png?v=1791070074",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8790702915766-finish-3-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8790702915766-color-3-square-oct04.png?v=1791070086",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8790702915766-finish-4-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8790702915766-color-4-square-oct04.png?v=1791070097",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791611736246-finish-1-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791611736246-color-1-square-oct04.png?v=1791070109",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791611736246-finish-2-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791611736246-color-2-square-oct04.png?v=1791070123",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791611736246-finish-3-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791611736246-color-3-square-oct04.png?v=1791070134",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791611736246-finish-4-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791611736246-color-4-square-oct04.png?v=1791070146",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791613112502-finish-1-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791613112502-color-1-square-oct04.png?v=1791070839",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791613112502-finish-2-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-studio-8791613112502-sep07.png",
    "width": 1254,
    "height": 1254,
    "method": "original fixed master already matches degree",
    "background": "#ffffff"
  },
  "hayz-wood-8791613112502-finish-3-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791613112502-color-3-square-oct04.png?v=1791070851",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791613112502-finish-4-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791613112502-color-4-square-oct04.png?v=1791070864",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791616749750-finish-1-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791616749750-color-1-square-oct04.png?v=1791070875",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791616749750-finish-2-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791616749750-color-2-square-oct04.png?v=1791070887",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791616749750-finish-3-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-studio-8791616749750-sep07.png",
    "width": 1254,
    "height": 1254,
    "method": "original fixed master already matches degree",
    "background": "#ffffff"
  },
  "hayz-wood-8791616749750-finish-4-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791616749750-color-4-square-oct04.png?v=1791070897",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "142.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789031452854-square-4-oct04.png?v=1791072030",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "146.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789031452854-square-5-oct04.png?v=1791072043",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "147.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789031452854-square-6-oct04.png?v=1791072054",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "166.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789031551158-square-4-oct04.png?v=1791072353",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "170.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789031551158-square-5-oct04.png?v=1791072378",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "176.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789031551158-square-6-oct04.png?v=1791072366",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "165.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789031551158-square-7-oct04.png?v=1791076952",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "160.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789031551158-square-8-oct04.png?v=1791076966",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "155.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789032075446-square-4-oct04.png?v=1791076979",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "159.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789032075446-square-5-oct04.png?v=1791076992",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "156.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789032075446-square-6-oct04.png?v=1791077004",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "150.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789032075446-square-7-oct04.png?v=1791077018",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "151.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789032075446-square-8-batch18-oct04.png?v=1791098619",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "191.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789034238134-square-4-batch18-oct04.png?v=1791098634",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "194.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789034238134-square-5-batch18-oct04.png?v=1791098647",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "193.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789034238134-square-6-batch18-oct04.png?v=1791098662",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "45.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8790702915766-square-4-batch18-oct04.png?v=1791099042",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "46.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8790702915766-square-5-batch18-oct04.png?v=1791099055",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "41.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8790702915766-square-6-batch18-oct04.png?v=1791099068",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "ChatGPTImageJun2_2026_12_35_51PM_7.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791611736246-square-4-batch18-oct04.png?v=1791099247",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "ChatGPTImageJun2_2026_12_35_50PM_6.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791611736246-square-5-batch18-oct04.png?v=1791099262",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "ChatGPTImageJun2_2026_12_35_52PM_8.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791611736246-square-6-batch18-oct04.png?v=1791099276",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "62.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791613112502-square-4-batch18-oct04.png?v=1791099443",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "61.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791613112502-square-5-batch18-oct04.png?v=1791099457",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "48.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791616749750-square-4-batch18-oct04.png?v=1791099649",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "54.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791616749750-square-5-batch18-oct04.png?v=1791099667",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "49.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791616749750-square-6-batch18-oct04.png?v=1791099680",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-sofa-8791641489590-kapi-04-distinct.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791641489590-kapi-4-square-batch19-oct04.png?v=1791101214",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-sofa-8791641489590-kapi-13-distinct.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791641489590-kapi-13-square-batch19-oct04.png?v=1791101258",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-sofa-8791641489590-kapi-15-distinct.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791641489590-kapi-15-square-batch19-oct04.png?v=1791101271",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-sofa-8791641489590-kapi-24-distinct.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791641489590-kapi-24-square-batch19-oct04.png?v=1791101286",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "4646.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791641489590-lifestyle-4-square-batch20-oct04.png?v=1791101945",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "5468.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791641489590-lifestyle-5-square-batch20-oct04.png?v=1791101959",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "598.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791641489590-detail-6-square-batch20-oct04.png?v=1791101973",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-sofa-8791641882806-kapi-04-distinct.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791641882806-kapi-4-square-batch21-plain-corrected-oct04.png?v=1791103633",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "9999.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791641882806-lifestyle-4-square-batch21-oct04.png?v=1791102896",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "55555.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791641882806-detail-5-square-batch21-oct04.png?v=1791102910",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-sofa-8791641882806-kapi-13-distinct.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791641882806-kapi-13-square-batch21-oct04.png?v=1791103617",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-8791641882806-kapi-4-square-batch21-oct04.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791641882806-kapi-4-square-batch21-plain-corrected-oct04.png?v=1791103633",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-sofa-8791641882806-kapi-15-distinct.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791641882806-kapi-15-square-batch21-oct04.png?v=1791103647",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-sofa-8791641882806-kapi-24-distinct.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791641882806-kapi-24-square-batch21-oct04.png?v=1791103661",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "87455.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791645094070-lifestyle-5-square-batch22-oct04.png?v=1791104255",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "999955.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791645094070-lifestyle-6-square-batch22-oct04.png?v=1791104270",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "99998.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791645094070-detail-7-square-batch22-oct04.png?v=1791104284",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-sofa-8791645094070-panda-01-distinct.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791645094070-panda-1-square-batch22-oct04.png?v=1791104619",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-sofa-8791645094070-panda-04-distinct.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791645094070-panda-4-square-batch22-oct04.png?v=1791104634",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-sofa-8791645094070-panda-08-distinct.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791645094070-panda-8-square-batch22-oct04.png?v=1791104650",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-sofa-8791645094070-panda-18-distinct.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791645094070-panda-18-square-batch22-oct04.png?v=1791104665",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-sofa-8791647060150-panda-04-distinct.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791647060150-panda-4-square-batch23-oct04.png?v=1791105018",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-sofa-8791647060150-panda-08-distinct.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791647060150-panda-8-square-batch23-oct04.png?v=1791105035",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-sofa-8791647060150-panda-18-distinct.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791647060150-panda-18-square-batch23-oct04.png?v=1791105050",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "554455.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791648764086-lifestyle-5-square-batch24-oct04.png?v=1791105640",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "55555555.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791648764086-lifestyle-6-square-batch24-oct04.png?v=1791105655",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "0313111.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791648764086-detail-7-square-batch24-oct04.png?v=1791105668",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "54454647.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791648764086-detail-8-square-batch24-oct04.png?v=1791105864",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "548787878.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791648764086-detail-9-square-batch24-oct04.png?v=1791105876",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "544854877.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791648764086-detail-10-square-batch24-oct04.png?v=1791105889",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791648764086-finish-1-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791648764086-color-12-square-batch24-oct04.png?v=1791106140",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791648764086-finish-2-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791648764086-color-13-square-batch24-oct04.png?v=1791106153",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791648764086-finish-3-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791648764086-color-14-square-batch24-oct04.png?v=1791106197",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791648764086-finish-4-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791648764086-color-15-square-batch24-oct04.png?v=1791106246",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "65655.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791648796854-lifestyle-6-square-batch24-oct04.png?v=1791106494",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "64993.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791648796854-lifestyle-7-square-batch24-oct04.png?v=1791106507",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "326444.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791648796854-lifestyle-8-square-batch24-oct04.png?v=1791106520",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "95544.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791648796854-lifestyle-9-square-batch24-oct04.png?v=1791106715",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "88947.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791648796854-detail-10-square-batch24-oct04.png?v=1791106728",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791648796854-finish-1-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791648796854-color-12-square-batch24-oct04.png?v=1791106741",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791648796854-finish-2-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791648796854-color-13-square-batch24-oct04.png?v=1791106954",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791648796854-finish-3-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791648796854-color-14-square-batch24-oct04.png?v=1791106966",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791648796854-finish-4-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791648796854-color-15-square-batch24-oct04.png?v=1791106978",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "0544787.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791648927926-lifestyle-5-square-batch24-oct04.png?v=1791107184",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "5485777.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791648927926-lifestyle-6-square-batch24-oct04.png?v=1791107196",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "888888.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791648927926-detail-7-square-batch24-oct04.png?v=1791107209",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "05487877.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791648927926-detail-8-square-batch24-oct04.png?v=1791107352",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791648927926-finish-1-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791648927926-color-10-square-batch24-oct04.png?v=1791107365",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791648927926-finish-2-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791648927926-color-11-square-batch24-oct04.png?v=1791107650",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791648927926-finish-3-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791648927926-color-12-square-batch24-oct04.png?v=1791107661",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791648927926-finish-4-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791648927926-color-13-square-batch24-oct04.png?v=1791107674",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "71.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8785226858678-lifestyle-6-square-batch25-oct04.png?v=1791108843",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "75.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8785226858678-lifestyle-7-square-batch25-oct04.png?v=1791108858",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "99.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8785229152438-lifestyle-5-square-batch25-oct04.png?v=1791108872",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "png_33_0945df80-1ef8-4f89-b011-294f3f7a329a.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8785229152438-lifestyle-6-square-batch25-oct04.png?v=1791108886",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "110.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8785230954678-lifestyle-5-square-batch25-oct04.png?v=1791108899",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "112.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8785230954678-lifestyle-6-square-batch25-oct04.png?v=1791108913",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "74.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8785226858678-detail-8-square-batch26-oct04.png?v=1791109149",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "96.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8785229152438-detail-7-square-batch26-oct04.png?v=1791109160",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "109.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8785230954678-detail-7-square-batch26-oct04.png?v=1791109173",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8785231052982-finish-2-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8785231052982-wood-2-square-batch27-oct04.png?v=1791109619",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8785231052982-finish-3-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8785231052982-wood-3-square-batch27-oct04.png?v=1791109632",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8785231052982-finish-4-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8785231052982-wood-4-square-batch27-oct04.png?v=1791109646",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8785231839414-finish-2-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8785231839414-wood-2-square-batch27-oct04.png?v=1791109658",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8785231839414-finish-3-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8785231839414-wood-3-square-batch27-oct04.png?v=1791109674",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8785231839414-finish-4-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8785231839414-wood-4-square-batch27-oct04.png?v=1791109687",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8785233576118-finish-2-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8785233576118-wood-2-square-batch27-oct04.png?v=1791109700",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8785233576118-finish-3-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8785233576118-wood-3-square-batch27-oct04.png?v=1791109713",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8785233576118-finish-4-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8785233576118-wood-4-square-batch27-oct04.png?v=1791109726",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8788488552630-finish-2-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8788488552630-wood-2-square-batch28-oct04.png?v=1791110552",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8788488552630-finish-3-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8788488552630-wood-3-square-batch28-oct04.png?v=1791110572",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8788488552630-finish-4-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8788488552630-wood-4-square-batch28-oct04.png?v=1791110586",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8788488650934-finish-2-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8788488650934-wood-2-square-batch28-oct04.png?v=1791110599",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8788488650934-finish-3-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8788488650934-wood-3-square-batch28-oct04.png?v=1791110612",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8788488650934-finish-4-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8788488650934-wood-4-square-batch28-oct04.png?v=1791110629",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789023522998-finish-2-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789023522998-wood-2-square-batch28-oct04.png?v=1791110640",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789023522998-finish-3-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789023522998-wood-3-square-batch28-oct04.png?v=1791110654",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789023522998-finish-4-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789023522998-wood-4-square-batch28-oct04.png?v=1791110666",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "236.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789023752374-mirror-lifestyle-5-square-batch29-oct04.png?v=1791111108",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "233.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789023752374-mirror-detail-6-square-batch29-oct04.png?v=1791111120",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "234.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789023752374-mirror-detail-7-square-batch29-oct04.png?v=1791111132",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "228.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789023817910-mirror-lifestyle-5-square-batch29-oct04.png?v=1791111145",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "227.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789023817910-mirror-detail-6-square-batch29-oct04.png?v=1791111158",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "230.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789023817910-mirror-detail-7-square-batch29-oct04.png?v=1791111169",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789023752374-finish-1-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789023752374-wood-1-square-batch30-oct04.png?v=1791112769",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "ChatGPTImageJun2_2026_12_58_18PM_5.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024211126-lifestyle-5-square-batch30-oct04.png?v=1791112785",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "ChatGPTImageJun2_2026_12_58_17PM_4.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024211126-detail-6-square-batch30-oct04.png?v=1791112799",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789024211126-finish-1-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024211126-wood-1-square-batch30-oct04.png?v=1791112815",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789023752374-finish-2-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789023752374-wood-2-square-batch31-oct04.png?v=1791113477",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789023752374-finish-3-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789023752374-wood-3-square-batch31-oct04.png?v=1791113504",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789023752374-finish-4-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789023752374-wood-4-square-batch31-oct04.png?v=1791113517",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789024211126-finish-2-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024211126-wood-2-square-batch31-oct04.png?v=1791113531",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789024211126-finish-3-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024211126-wood-3-square-batch31-oct04.png?v=1791113546",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789024211126-finish-4-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024211126-wood-4-square-batch31-oct04.png?v=1791113562",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "347.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030600886-lifestyle-5-square-batch31-oct04.png?v=1791113576",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "348.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030600886-lifestyle-6-square-batch31-oct04.png?v=1791113591",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "349.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030600886-detail-7-square-batch31-oct04.png?v=1791113605",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "340.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030764726-lifestyle-5-square-batch31-oct04.png?v=1791113620",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "341.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030764726-lifestyle-6-square-batch31-oct04.png?v=1791113634",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "239.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030764726-detail-7-square-batch31-oct04.png?v=1791113648",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "png_3_copy.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024342198-lifestyle-5-square-batch32-oct04.png?v=1791114395",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "png_3_copy_7b9ca675-ea57-422c-b60c-21e91b428787.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024342198-detail-6-square-batch32-oct04.png?v=1791114412",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789024342198-finish-1-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024342198-wood-1-square-batch32-oct04.png?v=1791114428",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "324.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030666422-lifestyle-5-square-batch32-oct04.png?v=1791114443",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "325.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030666422-lifestyle-6-square-batch32-oct04.png?v=1791114459",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "321.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030666422-detail-7-square-batch32-oct04.png?v=1791114474",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789030666422-finish-1-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030666422-wood-1-square-batch32-oct04.png?v=1791114488",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791622844598-finish-1-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791622844598-wood-1-square-batch32-oct04.png?v=1791114502",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791627038902-finish-1-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791627038902-wood-1-square-batch32-oct04.png?v=1791114516",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791633297590-finish-1-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791633297590-wood-1-square-batch32-oct04.png?v=1791114530",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791633625270-finish-1-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791633625270-wood-1-square-batch32-oct04.png?v=1791114545",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791635984566-finish-1-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791635984566-wood-1-square-batch32-oct04.png?v=1791114560",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789024342198-finish-2-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024342198-wood-2-square-batch33-oct04.png?v=1791115466",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789024342198-finish-3-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024342198-wood-3-square-batch33-oct04.png?v=1791115478",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789024342198-finish-4-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024342198-wood-4-square-batch33-oct04.png?v=1791115490",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789030666422-finish-2-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030666422-wood-2-square-batch33-oct04.png?v=1791115503",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789030666422-finish-3-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030666422-wood-3-square-batch33-oct04.png?v=1791115517",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8789030666422-finish-4-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030666422-wood-4-square-batch33-oct04.png?v=1791115530",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791622844598-finish-2-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791622844598-wood-2-square-batch33-oct04.png?v=1791115543",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791622844598-finish-3-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791622844598-wood-3-square-batch33-oct04.png?v=1791115555",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791622844598-finish-4-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791622844598-wood-4-square-batch33-oct04.png?v=1791115568",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791627038902-finish-2-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791627038902-wood-2-square-batch33-oct04.png?v=1791115579",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791627038902-finish-3-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791627038902-wood-3-square-batch33-oct04.png?v=1791115592",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791627038902-finish-4-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791627038902-wood-4-square-batch33-oct04.png?v=1791115606",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791633297590-finish-2-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791633297590-wood-2-square-batch34-oct04.png?v=1791116151",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791633297590-finish-3-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791633297590-wood-3-square-batch34-oct04.png?v=1791116166",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791633297590-finish-4-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791633297590-wood-4-square-batch34-oct04.png?v=1791116179",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "666.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791633625270-lifestyle-5-square-batch34-oct04.png?v=1791116194",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "hayz-wood-8791633625270-finish-2-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791633625270-wood-2-square-batch34-oct04.png?v=1791116207",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791633625270-finish-3-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791633625270-wood-3-square-batch34-oct04.png?v=1791116224",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791633625270-finish-4-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791633625270-wood-4-square-batch34-oct04.png?v=1791116241",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "8099.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791635984566-lifestyle-5-square-batch34-oct04.png?v=1791116254",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "800.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791635984566-detail-6-square-batch34-oct04.png?v=1791116266",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791635984566-finish-2-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791635984566-wood-2-square-batch34-oct04.png?v=1791116279",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791635984566-finish-3-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791635984566-wood-3-square-batch34-oct04.png?v=1791116293",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-wood-8791635984566-finish-4-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791635984566-wood-4-square-batch34-oct04.png?v=1791116307",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "png10.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024964790-lifestyle-5-square-batch35-oct04.png?v=1791117794",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "png12.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024964790-lifestyle-6-square-batch35-oct04.png?v=1791117806",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "png6.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024964790-lifestyle-7-square-batch35-oct04.png?v=1791117821",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "png7.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024964790-detail-8-square-batch35-oct04.png?v=1791117833",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "309.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030863030-lifestyle-5-square-batch35-oct04.png?v=1791117846",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "312.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030863030-lifestyle-6-square-batch35-oct04.png?v=1791117859",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "313.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030863030-detail-7-square-batch35-oct04.png?v=1791117873",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "315.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030961334-lifestyle-5-square-batch35-oct04.png?v=1791117887",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "320.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030961334-lifestyle-6-square-batch35-oct04.png?v=1791117900",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "314.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030961334-detail-7-square-batch35-oct04.png?v=1791117913",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "304.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030994102-lifestyle-5-square-batch35-oct04.png?v=1791117926",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "305.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030994102-detail-6-square-batch35-oct04.png?v=1791117939",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "212.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791622844598-lifestyle-5-square-batch35-oct04.png?v=1791117954",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "211.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791622844598-detail-6-square-batch35-oct04.png?v=1791117970",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "200.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791623106742-lifestyle-4-square-batch35-oct04.png?v=1791117984",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "204.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791624581302-lifestyle-5-square-batch35-oct04.png?v=1791117997",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "206.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791624581302-detail-6-square-batch35-oct04.png?v=1791118009",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "223.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791627038902-lifestyle-5-square-batch35-oct04.png?v=1791118022",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "225.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791627038902-detail-6-square-batch35-oct04.png?v=1791118037",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "219.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791628251318-lifestyle-5-square-batch35-oct04.png?v=1791118052",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "216.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791628251318-detail-6-square-batch35-oct04.png?v=1791118066",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "403.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791634935990-lifestyle-5-square-batch35-oct04.png?v=1791118080",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "410.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791634935990-lifestyle-6-square-batch35-oct04.png?v=1791118095",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "415.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791634935990-lifestyle-7-square-batch35-oct04.png?v=1791118107",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "continuous scene"
  },
  "402.webp": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791634935990-detail-8-square-batch35-oct04.png?v=1791118121",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-image-edit",
    "background": "#ffffff"
  },
  "hayz-solo-8789024342198-fabric-4-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024342198-fabric-4-only-square-batch36-oct04.png?v=1791120457",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789024342198-fabric-13-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024342198-fabric-13-only-square-batch36-oct04.png?v=1791120470",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789024342198-fabric-15-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024342198-fabric-15-only-square-batch36-oct04.png?v=1791120482",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789024342198-fabric-24-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024342198-fabric-24-only-square-batch36-oct04.png?v=1791120495",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789024342198-wood-1-fabric-4-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024342198-fabric-4-wood-1-square-batch36-oct04.png?v=1791120506",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789024342198-wood-1-fabric-13-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024342198-fabric-13-wood-1-square-batch36-oct04.png?v=1791120517",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789024342198-wood-1-fabric-15-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024342198-fabric-15-wood-1-square-batch36-oct04.png?v=1791120529",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789024342198-wood-1-fabric-24-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024342198-fabric-24-wood-1-square-batch36-oct04.png?v=1791120542",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789024342198-wood-2-fabric-4-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024342198-fabric-4-wood-2-square-batch36-oct04.png?v=1791120556",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789024342198-wood-2-fabric-13-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024342198-fabric-13-wood-2-square-batch36-oct04.png?v=1791120572",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789024342198-wood-2-fabric-15-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024342198-fabric-15-wood-2-square-batch36-oct04.png?v=1791120585",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789024342198-wood-2-fabric-24-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024342198-fabric-24-wood-2-square-batch36-oct04.png?v=1791120596",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789024342198-wood-3-fabric-4-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024342198-fabric-4-wood-3-square-batch36-oct04.png?v=1791120609",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789024342198-wood-3-fabric-13-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024342198-fabric-13-wood-3-square-batch36-oct04.png?v=1791120622",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789024342198-wood-3-fabric-15-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024342198-fabric-15-wood-3-square-batch36-oct04.png?v=1791120634",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789024342198-wood-3-fabric-24-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024342198-fabric-24-wood-3-square-batch36-oct04.png?v=1791120645",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789024342198-wood-4-fabric-4-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024342198-fabric-4-wood-4-square-batch36-oct04.png?v=1791120659",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789024342198-wood-4-fabric-13-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024342198-fabric-13-wood-4-square-batch36-oct04.png?v=1791120670",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789024342198-wood-4-fabric-15-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024342198-fabric-15-wood-4-square-batch36-oct04.png?v=1791120680",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789024342198-wood-4-fabric-24-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024342198-fabric-24-wood-4-square-batch36-oct04.png?v=1791120692",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030666422-fabric-4-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030666422-fabric-4-only-square-batch37-oct04.png?v=1791121074",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030666422-fabric-13-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030666422-fabric-13-only-square-batch37-oct04.png?v=1791121087",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030666422-fabric-15-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030666422-fabric-15-only-square-batch37-oct04.png?v=1791121098",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030666422-fabric-24-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030666422-fabric-24-only-square-batch37-oct04.png?v=1791121110",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030666422-wood-1-fabric-4-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030666422-fabric-4-wood-1-square-batch37-oct04.png?v=1791121127",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030666422-wood-1-fabric-13-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030666422-fabric-13-wood-1-square-batch37-oct04.png?v=1791121138",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030666422-wood-1-fabric-15-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030666422-fabric-15-wood-1-square-batch37-oct04.png?v=1791121150",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030666422-wood-1-fabric-24-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030666422-fabric-24-wood-1-square-batch37-oct04.png?v=1791121161",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030666422-wood-2-fabric-4-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030666422-fabric-4-wood-2-square-batch37-oct04.png?v=1791121176",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030666422-wood-2-fabric-13-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030666422-fabric-13-wood-2-square-batch37-oct04.png?v=1791121188",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030666422-wood-2-fabric-15-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030666422-fabric-15-wood-2-square-batch37-oct04.png?v=1791121201",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030666422-wood-2-fabric-24-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030666422-fabric-24-wood-2-square-batch37-oct04.png?v=1791121212",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030666422-wood-3-fabric-4-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030666422-fabric-4-wood-3-square-batch37-oct04.png?v=1791121226",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030666422-wood-3-fabric-13-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030666422-fabric-13-wood-3-square-batch37-oct04.png?v=1791121236",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030666422-wood-3-fabric-15-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030666422-fabric-15-wood-3-square-batch37-oct04.png?v=1791121247",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030666422-wood-3-fabric-24-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030666422-fabric-24-wood-3-square-batch37-oct04.png?v=1791121259",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030666422-wood-4-fabric-4-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030666422-fabric-4-wood-4-square-batch37-oct04.png?v=1791121273",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030666422-wood-4-fabric-13-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030666422-fabric-13-wood-4-square-batch37-oct04.png?v=1791121306",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030666422-wood-4-fabric-15-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030666422-fabric-15-wood-4-square-batch37-oct04.png?v=1791121285",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030666422-wood-4-fabric-24-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030666422-fabric-24-wood-4-square-batch37-oct04.png?v=1791121295",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8788488487094-wood-1-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8788488487094-wood-1-square-batch38-oct04.png?v=1791122717",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8788488487094-wood-2-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8788488487094-wood-2-square-batch38-oct04.png?v=1791122727",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8788488487094-wood-3-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8788488487094-wood-3-square-batch38-oct04.png?v=1791122752",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8788488487094-wood-4-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8788488487094-wood-4-square-batch38-oct04.png?v=1791122740",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789024407734-fabric-4-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024407734-fabric-4-square-batch38-oct04.png?v=1791122766",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789024407734-fabric-13-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024407734-fabric-13-square-batch38-oct04.png?v=1791122779",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789024407734-fabric-15-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024407734-fabric-15-square-batch38-oct04.png?v=1791122791",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789024407734-fabric-24-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024407734-fabric-24-square-batch38-oct04.png?v=1791122803",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789024964790-fabric-4-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024964790-fabric-4-square-batch38-oct04.png?v=1791122821",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789024964790-fabric-13-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024964790-fabric-13-square-batch38-oct04.png?v=1791122844",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789024964790-fabric-15-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024964790-fabric-15-square-batch38-oct04.png?v=1791122832",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789024964790-fabric-24-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789024964790-fabric-24-square-batch38-oct04.png?v=1791122857",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030600886-fabric-4-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030600886-fabric-4-square-batch38-oct04.png?v=1791122872",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030600886-fabric-13-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030600886-fabric-13-square-batch38-oct04.png?v=1791122885",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030600886-fabric-15-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030600886-fabric-15-square-batch38-oct04.png?v=1791122910",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030600886-fabric-24-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030600886-fabric-24-square-batch38-oct04.png?v=1791122898",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030764726-fabric-4-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030764726-fabric-4-square-batch38-oct04.png?v=1791122926",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030764726-fabric-13-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030764726-fabric-13-square-batch38-oct04.png?v=1791122937",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030764726-fabric-15-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030764726-fabric-15-square-batch38-oct04.png?v=1791122950",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030764726-fabric-24-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030764726-fabric-24-square-batch38-oct04.png?v=1791122963",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030863030-fabric-4-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030863030-fabric-4-square-batch38-oct04.png?v=1791122978",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030863030-fabric-13-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030863030-fabric-13-square-batch38-oct04.png?v=1791122990",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030863030-fabric-15-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030863030-fabric-15-square-batch38-oct04.png?v=1791123002",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030863030-fabric-24-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030863030-fabric-24-square-batch38-oct04.png?v=1791123014",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030994102-fabric-4-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030994102-fabric-4-square-batch38-oct04.png?v=1791123030",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030994102-fabric-13-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030994102-fabric-13-square-batch38-oct04.png?v=1791123045",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030994102-fabric-15-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030994102-fabric-15-square-batch38-oct04.png?v=1791123058",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8789030994102-fabric-24-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8789030994102-fabric-24-square-batch38-oct04.png?v=1791123072",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8791634935990-wood-1-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791634935990-wood-1-square-batch38-oct04.png?v=1791123086",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8791634935990-wood-2-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791634935990-wood-2-square-batch38-oct04.png?v=1791123097",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8791634935990-wood-3-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791634935990-wood-3-square-batch38-oct04.png?v=1791123109",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-solo-8791634935990-wood-4-oct01.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791634935990-wood-4-square-batch38-oct04.png?v=1791123122",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-wood-8788488487094-finish-2-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8788488487094-wood-2-square-batch38-oct04.png?v=1791122727",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-wood-8788488487094-finish-3-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8788488487094-wood-3-square-batch38-oct04.png?v=1791122752",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-wood-8788488487094-finish-4-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8788488487094-wood-4-square-batch38-oct04.png?v=1791122740",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-wood-8791634935990-finish-1-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791634935990-wood-1-square-batch38-oct04.png?v=1791123086",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-wood-8791634935990-finish-2-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791634935990-wood-2-square-batch38-oct04.png?v=1791123097",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-wood-8791634935990-finish-3-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791634935990-wood-3-square-batch38-oct04.png?v=1791123109",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  },
  "hayz-wood-8791634935990-finish-4-lifestyle.png": {
    "url": "https://cdn.shopify.com/s/files/1/0724/8887/8262/files/hayz-8791634935990-wood-4-square-batch38-oct04.png?v=1791123122",
    "width": 1254,
    "height": 1254,
    "method": "reference-based-colour-correction",
    "background": "#ffffff"
  }
});
